module.exports = {
  message: {
    hello: 'Hello ',
    switchLanguage: 'Switch Language',
    switchSystem: 'Switch System',
    logout: 'Logout',
    theme: 'Theme',
    restore: 'Restore',
    uploadFile: "Click Or Drag File Here",
    uploadTemplate: "Upload Template",
    selectTemplate: "Select Template",
    templateName: "Template Name",
    import: "Import",
    ActiveorNot:'Active or Not',
    ExpiryDate:'Expiry Date',
    Expiry:'Expiry',
    close:'close',
    ActivationCode:'Activation Code',
    getActivationCode:'get Activation Code',
    ActivationType:'Activation Time',
    select:'Select',
    tips:'According to the best practices recommended by AWS, the AKSK account access method is not recommended, but the AssumeRole access method is recommended。',
    noPermission: 'No permission, please contact the administrator',
    managementSystem: 'Management System'
  },
  // 账单数据
  BillingServices:{
    BillingRules:'Billing Rules',
    Dataprocessingrules:'Data Processing Rules',
    Pleaseselectacompany:'Please Select A Company',
    Querybyrulename:'Query By Rule Name',
    select:'Select',
    AddRule:'Add Rule',
    companyName:'Company Name',
    ruleName:'Rule Name',
    Cloudplatformtype:'Cloud Platform Type',
    Billingdatasource:'Billing Data Source ',
    Appliedlabelrules:'Applied Label Rules',
    oper:'Operation',
    del:'Del',
    Operationlog:'Operation Log',
    AddProcessingRule:'Add Processing Rule',
    company:'Company',
    WhetherRIprocessingisrequired:'Whether RI Processing Is Required',
    LabelRules:'Label Rules',
    cancel:'Cancel',
    add:'Add',
    edit: "Edit",
    EditProcessingRule:'Edit Processing Rule',
    confirm:'Confirm',
    Operationmodule:'Operation Module',
    Operationfield:'Operation Field',
    Originalvalue:'Original Value',
    Newvalue:'New Value',
    Operator:'Operator',
    UpdateTime:'Update Time',
    Labelhandlingrules:'Label Handling Rules',
    conditionsforexecution:'Conditions For Execution',
    Conditioncontent:'Condition Content',
    Executeaction:'Execute Action',
    Satisfyanyone :'Satisfy Any One',
    Meetall:'Meet All',
    PleaseentertagKey:'Please Enter TagKey',
    PleaseentertagValue:'Please Enter TagValue',
    AddLabel:'AddLabel',
    // 新加
    AddLabelRule:'Add Label Rule',
    editLabelRule:'Edit Label Rule',

    // 导出
    BillExport:'Bill Export',
    ExportAWSbill:'Export AWS bill',
    ExportRecords:'Export Records',
    ExportTemplate:'Export Template',
    Querybyrecordname:'Query by record name',
    QuerybyTemplateName:'Query by Template Name',
    Pleaseselecttheexportstatus:'Please select the export status',
    export:'Export',
    Recordname:'Record name',
    Accountlists:'Account list',
    Billingtimerange:'Billing time range',
    status:'Status',
    TemplateName:'Template Name',
    ExportListFields:'Export List Fields',
    ExportStatisticsFields:'Export Statistics Fields',
    Exporttagfield:'Export tag field',
    Exporttime:'Export time',
    download:'Download',
    DownloadRecords:'Download Records',
    ExportRecordName:'Export Record Name',
    ListFields:'List Fields',
    Statisticalields:'Statistic Aields',
    Tagfield:'Tag Field',
    Downloader:'Downloader',
    Downloadtime:'Download Time',
    addtemplate:'Add Template',
    Cloudplatformtype:'Cloud Platform Type',
    Billofaccountcloudplatform:'Bill Of Accountcloud Platform',
    AccountList:'Account List',
    EditTemplate:'Edit Template',
  },
  // 仪表盘菜单
  dashboard: {
    dashboard: 'Dashboard',
    tickets: 'Tickets',
    ticket: 'Ticket',
    averageResponseTime: 'Response Time',
    maximumLevel: 'Maximum Level',
    eventCreation: 'Event Creation',
    currentBacklog: 'To Do',
    hosts: 'Hosts',
    host: 'Host',
    running: 'Running',
    stopping: 'Stopping',
    hostCreation: 'Host Creation',
    alarms: 'Monitor',
    securityRating: 'Security Rating',
    security: 'Security',
    totalRisks: 'Total  Risks',
    highRisks: 'High Risks',
    baselineProblems: 'Baseline Problems',
    holes: 'Holes',
    sumCost: 'Total (Tax Included)',
    cost: 'Cost',
    currentCost: 'Current',
    cumulative: 'Cumulative',
    expected: 'Expected',
    recharge: 'Recharge',
    date: 'Date',
    balance: 'Balance',
    spendingThan: 'Month-to-Date Spend By Tag',
    backlog: 'Top Events',
    subject: 'Subject',
    classification: 'Classification',
    serious: 'Serious',
    updateTime: 'Update Time',
    status: 'Status',
    resourceCreated: 'Resource(Created)',
    log: 'Log',
    netRejection: 'Net Rejection',
    resourceDeletion: 'Resource Delete',
    resourceChange: 'Resource Change',
    exceptionRequest: 'Exception Request',
    estimatedTotal: 'Estimated Total',
    noMatchRI: 'No Match RI',
    rISaving: 'RI Saving',
    // 待办事项
    theme: 'Theme',
    resource: 'Resource',
    priority: 'Priority',
    modifiedTime: 'Modified Time'
  },
  // 案例菜单
  ticket: {
    // 案例列表
    list: {
      isReply: 'IsReply',
      ticket: 'List',
      addTicket: 'Add Ticket',
      addComment: 'Add Comment',
      category: 'Category',
      subject: 'Subject',
      status: 'Status',
      monitorModule: 'Monitor Module',
      level: 'Level',
      assignee: 'Assignee',
      attachment: 'Attachment',
      description: 'Description',
      cancel: 'Cancel',
      confirm: 'Confirm',
      ticketEntityID: 'Ticket Entity ID',
      operation: 'Operation',
      delete: 'Delete',
      detail: 'Detail',
      ticketDetail: 'Ticket Details',
      export: 'Export',
      return: 'Return',
      reporter: 'Reporter',
      date: 'Date',
      createdDate: 'Created Date',
      modifiedDate: 'Modified Date',
      comment: 'Comment',
      addedComments: 'Added Comments',
      changeRecord: 'Change Record',
      operator: 'Operator',
      fieldType: 'Field Type',
      originalValue: 'Original Value',
      newValue: 'New Value',
      modifiedTime: 'Modified Time',
      attachmentList: 'Attachment List',
      fileName: 'File Name',
      storagePath: 'Storage Path',
      affirmDownload: 'Download the confirmation',
      personnel: 'Personnel',
      createdTime: 'Created Time',
      finishTime: 'Finish Time',
      handleTime: 'Handle Time',
      waitTime: 'Wait Time',
      Process: 'Process',
      selectByCaseId: 'Case ID',
      selectByCompany: 'Company',
      selectByPriority: 'Priority',
      selectByStatus: 'Status',
      selectByProblemTypes: 'Problem Types',
      selectByOperator: 'Operator',
      selectByDate: 'Date',
      closeReason: 'Close Reason',
      confirmMan: 'Confirmor',
      editTicket: 'Edit Ticket',
      allocation: 'Allocation',
      keyDistribution: 'A key distribution',
      enableKeyDistribution: 'Are you sure you want to use one-key allocation?',
      Pending: 'Pending',
      Processing: 'Processing',
      Finish: 'Finish',
      WaitingForTheAuthorization: 'Waiting For The Authorization',
      CheckNozzle: 'CheckNozzle',
      UnderReview: 'UnderReview',
      TheAuditFails: 'The AuditFails',
      Approved: 'Approved',
      Confirming: 'Confirming',
      Confirmed: 'Confirmed',
      updateStatus:'UpdateStatus',
      list:'List',
      continuePurchase:'Continue Purchase'
    },
    // 评论
    comment: {
      addComments: "Add Comments",
      comment: "Comment",
      changeRecord: "Change Record",
      attachmentList: "The Attachment List",
      confirmDownload: "Are you sure you want to download ",
      what: "",
      download: "Download",
      responsiblePerson: "Responsible Person",
      operationType: "Operation Type",
      originValue: "Origin Value",
      newValue: "New Value",
      description: "Description",
      updateTime: "Update Time",
      fileName: "File Name",
      fileType: "File Type",
      storagePath: "Storage Path",
      pleaseEnterDescription: "Please Enter A Description",
    },
    // 案例仪表盘
    dashboard: {
      realTimeStatistics: 'Real Time Statistics',
      status: 'Status',
      averageResponseTime: 'Average Response Time',
      responseTime: 'Response Time',
      count: 'Count'
    }
  },

  // 监控告警管理菜单
  alarms: {
    // 实例
    instance: {
      instance: 'Instance',
      hostInformation: 'Host Information',
      instanceConfiguration: 'Instance Configuration',
      accountType: 'Account Type',
      disk: 'Disk',
      systemDisk: 'System Disk',
      dateDisk: 'Date Disk',
      instanceId: 'Instance ID',
      addInstanceAlarm: 'Add Instance Alarm',
      editInstanceAlarm: 'Edit Instance Alarm',
      instanceName: 'Instance Name',
      accountName: 'Account Name',
      ip: 'IP',
      state: 'State',
      region: 'Region',
      cpuUsage: 'CPU Usage',
      memoryUsage: 'Memory Usage',
      diskSpaceUsage: 'Disk Space Usage',
      networkInput: 'Network Input',
      networkOutput: 'Network Output',
      instanceHealthCheck: 'Instance Health Check',
      systemHealthCheck: 'System Health Check',
      instanceMaintenanceInformation: 'Instance Maintenance Information',
      frequentLoginFailures: 'Frequent Login Failures',
      linuxInodeUsage: 'Linux Inode Usage',
      instanceList: 'Instance List',
      total: 'Total',
      diskSize: 'Disks',
      publicIp:"Public Ip",
      allocationId:"Allocation Id",
      privateIp:"Private Ip",
      // 折线图
      line:{
        MemoryAvailability:'Memory Availability',
        swapUsage:'Swap Usage',
        volumeReadIOPs:'Volume ReadIOPs',
        volumeWriteIOPs:'Volume WriteIOPs',
        ReadIOPs:'Read IOPs',
        WriteIOPs:'Write IOPs',
        readLatency:'Read Latency',
        writeLatency:'Write Latency',
        CPUUtilizationPercent:'CPU Utilization(%)',
        CPUUtilization:'CPU Utilization',
        CPUUtilizationForecast:'CPU Utilization Forecast',
        MemoryUsagePercentage:'Memory Usage(%)',
        MemoryUsage:'Memory Usage',
        MemoryUsageForecast:'Memory Usage Forecast',
        DiskUtilizationPercent:'Disk Utilization(%)',
        DiskUtilizationPercentForecast:'Disk Utilization Forecast(%)',
        DiskUtilization:'Disk Utilization',
        LinuxInodeUtilizationPercentage:'Linux Inode Utilization(%)',
        DiskReadAndWriteBytes:'Disk Read And Write(Bytes)',
        DiskRead:'Disk Read',
        DiskWrite:'Disk Write',
        DiskReadForecast:'Disk Read Forecast',
        DiskWriteForecast:'Disk Write Forecast',
        ReadAndWriteDiskOperationsOperations:'Read And Write Disk(Operations)',
        DiskReadOperation:'Disk Read Operation',
        DiskWriteOperation:'Disk Write Operation',
        DiskReadOperationForecast:'Disk Read Operation Forecast',
        DiskWriteOperationForecast:'Disk Write Operation Forecast',
        NetworkInputAndOutputBytes:'Network Input And Output(Bytes)',
        NetworkInput:'Network Input',
        NetworkOutput:'Network Output',
        NetworkInputForecast:'Network Input Forecast',
        NetworkOutputForecast:'Network Output Forecast',
        IncomingAndOutgoingNetworkPacketsNumber:'Incoming And Outgoing Network Packets(Number)',
        IncomingNetworkPackets:'Incoming Network Packets',
        OutgoingNetworkPackets:'Outgoing Network Packets',
        IncomingNetworkPacketsForecast:'Incoming Network Packets Forecast',
        OutgoingNetworkPacketsForecast:'Outgoing Network Packets Forecast',
        StatusCheckFailedArbitraryQuantity:'Status CheckFailed(Arbitrary)(Quantity)',
        StatusCheckFailedOptional:'Status CheckFailed(Arbitrary)',
        StatusCheckFailedInstanceQuantity:'Status CheckFailed(Instance)(Quantity)',
        StatusCheckFailedExample:'Status CheckFailed(Instance)',
        StatusCheckFailedSystemQuantity:'Status CheckFailed(System)(Quantity)',
        StatusCheckFailedSystem:'Status CheckFailed(System)',
        CPUQuotaUsageQuantity:'CPUQuotaUsageQuantity(Quantity)',
        CPUCreditUsage:'CPU Credit Usage',
        CPUQuotaBalanceQuantity:'CPU QuotaBalance(Quantity)',
        CPUQuotaBalance:'CPU QuotaBalance',
        DiskSpaceUsagePercentage:'Disk SpaceUsage Percentage',
        DiskSpaceUsage:'Disk SpaceUsage',
        NetworkIncomingBandwidthBit:'Network Incoming Bandwidth(bit/s)',
        IncomingInternetBandwidth:'Incoming Internet Bandwidth',
        InboundBandwidthFromPrivateNetwork:'Inbound Bandwidth From PrivateNetwork',
        NetworkOutgoingBandwidthBit:'Network Outgoing Bandwidth(bit/s)',
        PublicNetworkOutgoingBandwidth:'Public Network Outgoing Bandwidth',
        PrivateNetworkOutgoingBandwidth:'Private Network Outgoing Bandwidth',
        AverageDiskBPSBps:'Average Disk(Bps)',
        DiskTotalReadBPS:'Disk Total Read BPS',
        DiskTotalWriteBPS:'Disk Total Write BPS',
        DiskAverageIOPSTimesSec:'Disk Average IOPS(Time/s)',
        DiskReadIOPS:'Disk Read IOPS',
        DiskWriteIOPS:'Disk Write IOPS',
        StandardCpuUsage:"Standard Cpu Usage",
        StandardMemoryUsage:"Standard Memory Usage",
        StandardConnectionUsage:"Standard Connection Usage",
        StandardQPSUsage:"Standard QPS Usage",
        StandardIntranetRatio:"Standard Intranet Ratio",
        StandardIntranetInRatio:"Standard Intranet In Ratio",
        StandardIntranetOutRatio:"Standard Intranet Out Ratio",
        VpcPublicIpInternetOutRatePercent:"Vpc PublicIp Internet Out Rate Percent(bit/s)",
        CacheHitRatio:"Cache Hit Ratio",
        RedisCpuUtilization:"Redis Cpu Utilization",
        KeyspaceMisses:"Keyspace Misses",
        SystemMemoryUsageRatio:"System Memory Usage Ratio",
        UsageRatio:"Usage Ratio",
        ConnectionsTotal:"Connections Total",
        UpTime :"UpTime(s)",
        SystemUpTime:"SystemUpTime(h)",
      }
    },
    // 磁盘
    disk: {
      disk: 'Disk',
      addDiskAlarm: 'Add Disk Alarm',
      editDiskAlarm: 'Edit Disk Alarm',
      name: 'Disk Name',
      diskId: 'Disk ID',
      capacity: 'Capacity',
      type: 'Type',
      iops: 'IOPS',
      encrypted: 'Encrypted',
      region: 'Region',
      state: 'State',
      deviceName: 'Device Name',
      volumeNotAttached: 'Volume Not Attached',
      volumeReadWritePRIOPS: 'Volume Read And Write PRIOPS',
      volumeReadWriteOps: 'Volume Read And Write IOPS',
      readIOPS: 'Read IOPS',
      writeIOPS: 'Write IOPS',
      diskList: "Disk List",
      filterByDiskId:'Disk Id',
      filterByDiskName:'Disk Name',
      diskDescription:'Disk Description',
      diskConfig:'Disk Config',
      diskInformation:'Disk Information',
      // 折线图
      line:{
        DiskReadAndWriteIOPSIOPS:'Disk Read And Write IOPS(IOPS)',
        DiskReadIOPS:'Disk Read IOPS',
        DiskWriteIOPS:'Disk Write IOPS',
        DiskReadIOPSIOPS:'Disk Read IOPS(IOPS)',
        DiskWriteIOPSIOPS:'Disk Write IOPS(IOPS)',
        // DiskReadIOPSIOPSForecast:'Disk Read IOPS Forecast(IOPS)',
        // DiskWriteIOPSIOPSForecast:'Disk Write IOPS Forecast(IOPS)',
        DiskSpaceUsage:'Disk Space Usage(%)',
        // DiskSpaceUsageForecast:'Disk Space Usage Forecast(%)',
        TheTotalNumberOfSecondsSpentInReadAndWriteOperationsSeconds:'Total InRead And Write(s)',
        TheTotalNumberOfSecondsSpentInReadAndWriteOperationsSecondsForecast:'Total InRead And Write Forecast(s)',
        TheTotalNumberOfSecondsSpentInTheReadOperation:'Total Spent InRead',
        TheTotalNumberOfSecondsSpentInWriteOperations:'Total Spent InWrite',
        TheTotalNumberOfSecondsSpentInTheReadOperationForecast:'Total Spent InRead Forecast',
        TheTotalNumberOfSecondsSpentInWriteOperationsForecast:'Total Spent InWrite Forecast',
        ReadAndWriteThroughputOpss:'Read And Write Throughput(Ops/s)',
        ReadThroughput:'Read Through Put',
        WriteThroughput:'Write Through Put',
        ReadThroughputForecast:'Read Through Put Forecast',
        WriteThroughputForecast:'Write Through Put Forecast',
        ReadAndWriteBandwidthBytes:'Read And Write Bandwidth(Bytes)',
        ReadBandwidth:'Read Bandwidth',
        WriteBandwidth:'Write Bandwidth',
        ReadBandwidthForecast:'Read Bandwidth Forecast',
        WriteBandwidthForecast:'Write Bandwidth Forecast',
        BurstBalancePercentage:'Burst Balance(%)',
        BurstBalance:'Burst Balance',
        AverageQueueLengthSeconds:'Average Queue Length(s)',
        AverageQueueLength:'Average Queue Length',
        PercentageOfIdleTimeSeconds:'Percentage Of IdleTime(s)',
        PercentageOfIdleTime:'Percentage Of IdleTime',
        PercentageOfIdleTime:'PercentageOfIdleTime',
        SpaceUsage:"SpaceUsage(MB)",
        // SpaceUsageForecast:"SpaceUsage Forecast(MB)",
        InodeUtilization:"InInodeUtilizationode(%)",
        DiskReadAndWriteBPS:"Disk Read And WriteBPS(bytes/s)",
        DiskReadBPS:"Disk Read BPS",
        DiskWriteBPS:"Disk Write BPS",
        // DiskReadBPSForecast:"Disk Read BPS Forecast",
        // DiskWriteBPSForecast:"Disk Write BPS Forecast",
        DiskReadAndWriteRequestCount:"Disk Read And Write Request Count(count/s)",
        DiskReadRequestCount:"Disk Read Request Count",
        DiskWriteRequestCount:"Disk Write Request Count",
        // DiskReadRequestCountForecast:"Disk Read Request Count Forecast",
        // DiskWriteRequestCountForecast:"Disk Write Request Count Forecast",
        TotalCPUCurrentlyPercent:"Total CPU Currently Percent",
        TotalCPUCurrently:"Total CPU Currently",
        NetWorkPackage:"Net Work Package",
        NetworkinPackages:"Net work In Packages",
        NetworkoutPackages:"Net work Out Packages",
        TcpConnection:"TcpConnection",
        ESTABLISHED:"ESTABLISHED",
        NON_ESTABLISHED:"NON_ESTABLISHED",
        TCP_TOTAL:"TCP_TOTAL",
        AverageSystemLoad:"Average System Load",
        load1m:"Load1m",
        load5m:"Load5m",
        load15m:"Load15m",
        NetworkRate:"Network Rate",
        NetworkinRate:"Network In Rate",
        NetworkoutRate:"Network Out Rate",
        CpuUsageTimeSecond:"Cpu Usage Time Second",
        CpuUsageTime:"Cpu Usage Time",
        DiskReadBytesCountKiBS:"Disk Read Bytes Count KiBs(KiB/s)",
        DiskReadBytesCount:"Disk Read Bytes Count",
        DiskWriteBytesCountKIBs:"Disk Write Bytes Count KIBs(KiB/s)",
        DiskWriteBytesCount:"Disk Write Bytes Count",
        DiskMaxWriteOpsCount:"",
        DiskMaxReadOpsCount:"",
        DiskReadOpsCountTimesSec:"Disk Read Ops Count Times Sec(次/秒)",
        DiskReadOpsCount:"Disk Read Ops Count",
        DiskPercentUsedPercentage:"Disk Percent Used Percentage",
        DiskPercentUsed:"Disk Percent Used",
        gcpDiskBytesUsed:"Disk Bytes_used(GiB)",
        gcpDiskIOTime:"Disk Io_time(ms/s)",
        gcpDiskOperationCount:"Disk Operation Count(count/s)"
      }
    },
    // 数据库
    database: {
      accountName: 'Account',
      database: 'Database',
      name: 'Database Name',
      databaseId: 'Database ID',
      engine: 'Database Engine',
      type: 'Database Type',
      databaseInformation: 'Database Information',
      databaseConfiguration: 'Database Configuration',
      storage: 'Storage',
      storageType: 'Storage Type',
      addDatabaseAlarm: 'Add Database Alarm',
      editDatabaseAlarm: 'Edit Database Alarm',
      instanceType: 'Instance Type',
      instanceId: 'Instance ID',
      cpuUsage: 'CPU Usage',
      memoryUsage: 'Memory Usage',
      diskSpaceUsage: 'Disk Space Usage',
      databaseConnections: 'Database Connections',
      instanceMaintenanceInformation: 'Instance Maintenance Information',
      readThroughput: 'Read Throughput',
      writeThroughput: 'Write Throughput',
      readWriteIOPS: 'Read And Write IOPS',
      ioConsumptionPercent: 'IO Consumption Percent',
      ip: 'IP',
      state: 'State',
      region: 'Region',
      filterByDBInstance: 'DB Instance',
      databaseList: 'Database List',
      // 折线图
      line:{
        CPUUtilizationPercent:'CPU Utilization(%)',
        CPUUtilization:'CPU Utilization',
        CPUUtilizationForecast:'CPU Utilization Forecast',
        NumberOfDatabaseConnectionsNumber:'Number Of Database Connections(Count)',
        NumberOfDatabaseConnectionsNumberForecast:'Number Of Database Connections Forecast',
        NumberOfDatabaseConnections:'Number Of Database Connections',
        AvailableStorageSpaceBytes:'Available Storage Space(Bytes)',
        AvailableStorageSpace:'Available Storage Space',
        AvailableStorageSpaceBytesForecast:'Available Storage Space Forecast',
        AvailableMemoryMB:'Available Memory(%)',
        AvailableMemory:'Available Memory',
        AvailableMemoryForecast:'Available Memory Forecast',
        ReadAndWriteIOPSTimesSecond:'Read And Write IOPS(%)',
        ReadIOPS:'Read&Write IOPS',
        WriteIOPS:'Write IOPS',
        ReadIOPSForecast:'Read IOPS Forecast',
        WriteIOPSForecast:'Write IOPS Forecast',
        QueueDepthNumber:'Queue Depth(count)',
        QueueDepth:'Queue Depth',
        BinaryLogDiskUsageMB:'Binary Log Disk Usage(MB)',
        BinaryLogDiskUsage:'Binary Log Disk Usage',
        ReadAndWriteThroughputMBSec:'Read And Write Throughput(MB/s)',
        ReadThroughput:'Read Throughput',
        WriteThroughput:'Write Throughput',
        ReadThroughputForecast:'Read Throughput Forecast',
        WriteThroughputForecast:'Write Throughput Forecast',
        CPUUsagePercentage:'CPU Usage(%)',
        CpuUsage:'Cpu Usage',
        ConnectionUsagePercentage:'Connection Usage(%)',
        ConnectionUsageRate:'Connection Usage Rate',
        MemoryUsagePercentage:'Memory Usage(%)',
        MemoryUsage:'Memory Usage',
        DiskUsagePercentage:'Disk Usage(%)',
        DiskUsage:'Disk Usage',
        IOPSUsageRatePercentage:'IOPS Usage Rate(%)',
        IOPSUsageRate:'IOPS Usage Rate',
        StorageUtilizationPercentage:'Storage Utilization(%)',
        StorageUtilization:'Storage Utilization',
        MemoryUtilizationPercentage:'Memory Utilization(%)',
        MemoryUtilization:'Memory Utilization',
        ActiveConnectionsCount:'Active Connections(Count)',
        ActiveConnections:'Active Connections',
        IOUtilizationPercentage:'IO Utilization(%)',
        IOUtilization:'IO Utilization',
        ProcessMemoryPercentagePercentage:'Process Memory Percentage(%)',
        ProcessMemoryPercentage:'Process Memory Percentage',
        NumberOfSuccessfulConnectionsCount:'Number Of Successful Connections(Count)',
        NumberOfSuccessfulConnections:'Number Of Successful Connections',
        NetworkInputBits:"Network Input Bits(bits/s)",
        NetworkInput:"Network Input",
        NetworkOutBits:"Network Out Bits(bits/s)",
        NetworkOut:"Network Out",
        SqlDiskReadOPSCount:"Sql Disk Read OPS(Count)",
        SqlDiskReadOPS:"Sql Disk Read OPS",
        SqlDiskWriteOPSCount:"Sql Disk Write OPS(Count)",
        SqlDiskWriteOPS:"Sql Disk Write OPS",
        SqlCpuUsageS:"Sql Cpu Usage(s)",
        SqlCpuUsage:"Sql Cpu Usage",
        SqlCpuUtilizationPercentage:"Sql Cpu Utilization(%)",
        SqlCpuUtilization:"Sql Cpu Utilization",
        DiskUtilizationPercentage:"Disk Utilization(%)",
        DiskUtilization:"Disk Utilization",
        SqlMemoryUtilizationPercentage:"Sql Memory Utilization(%)",
        SqlMemoryUtilization:"Sql Memory Utilization",
        SqlReceivedBytesByte:"Sql Received Bytes(byte)",
        SqlReceivedBytes:"Sql Received Bytes",
        NetworkConnectionsCount:"Network Connections(Count)",
        NetworkConnections:"Network Connections",
        MemoryTotalUsageInnoDB:"Memory Total Usage InnoDB",
        MemoryTotalUsageInnoDBMb:"Memory Total Usage InnoDB(MB)",
        InnodbPagesTotal:"Innodb Pages Total",
        rdsReplicaLag: 'RDS ReplicaLag(s)',
        rdsReadOnly: 'Read-only copy synchronization delay'
      }
    },
      //弹性IP
      elasticResource:{
        elasticResource:"Elastic Resource",
        addEipAlarm: 'Add Eip Alarm',
        editEipAlarm:"Edit Eip Alarm",
        elasticResourceList:"Elastic Resource List",
        elasticResourceConfig:"Elastic Resource Config",
        type:"Type",
        elasticResourceInformation:"Elastic Resource Information",
        elasticResourceId:"Elastic ResourceId",
        allocationId:"Allocation Id",
        instanceId:"Instance Id",
        privateIp:"Private Ip",
        //折线图
        line:{
          NetrxPkgsRate:"Netrx Pkgs Rate",
          NettxPkgsRate:"Nettx Pkgs Rate",
          NetrxRate:"Net Rx Rate(bit/s)",
          NettxRate:"Net Tx Rate(bit/s)",
          NetInRatePercentage:"Net In Rate Percentage(%)",
          NetOutRatePercentage:"Net Out Rate Percentage(%)",
          OutRateLimitDropSpeed:"Out Rate Limit Drop Speed(Packets/Second)"
        },
      },
    // 财务
    billing: {
      contactGroup: "Contact Group",
      contact: "Contact",
      contactWay: "Contact Way",
      approval: "Approval",
      monitorIndex: 'MonitorIndex',
      pleaseSelectMonitorIndex: "Please Select Monitor Index",
      alertRuleDesc: 'AlertRule Desc',
      accountGroup: 'Account Group',
      singleAccount: 'Single Account',
      account: 'Account',
      type: 'Type',
      alertRuleName: 'AlertRule Name',
      cloudType: 'Cloud Type',
      billing: 'Billing',
      addBillingAlarm: 'Add Billing Alarm',
      editBillingAlarm: 'Edit Billing Alarm',
      accountGroupName: 'Account Group Name',
      region: 'Region',
      resourceType: 'Resource Type',
      filterByBillingType: 'Billing Type',
      filterByResourceType: 'Resource Type'
    },
    // 日志
    log: {
      keyword: 'Keyword',
      // 应用
      application: {
        application: 'Application',
        addLogAlarm: 'Add Log Alarm',
        editLogAlarm: 'Edit Log Alarm',
        instanceId: 'Instance Id',
        name: 'Name',
        ip: 'IP',
        region: 'Region'
      },
      // 安全
      security: {
        eventWriteType: 'Write',
        eventReadType: 'Read',
        eventAllType: 'All'
      },
      cloudTrail: {
        addCloudTrailAlertRule: 'Add CloudTrail AlertRule',
        updateCloudTrailAlertRule: 'Update CloudTrail AlertRule',
        eventCheck: 'Event Check'
      }
    },
    // 队列
    queue: {
      addQueue: 'Add Queue',
      queue: 'Queue',
      queueDescription: 'Queue Description',
      queueConfiguration: 'Queue Configuration',
      agentName: 'Agent Name',
      agentInstanceType: 'Agent Instance Type',
      agentEngine: 'Agent Engine',
      configurationInformation: 'Configuration Information',
      configurationName: 'Name',
      name: 'Broker Name',
      brokerId: 'Broker Id',
      pleaseEnterBrokerId: "Please Enter BrokerId",
      brokerEngine: 'Broker Engine',
      instanceType: 'Instance Type',
      region: 'Region'
    },
    // 对象存储
    objectStorage: {
      objectStorage: 'Object Storage',
      objectStorageDescription: 'ObjectStorage Description',
      objectStorageConfiguration: 'ObjectStorage Configuration',
      configurationInformation: 'Configuration Information',
      bucketName: 'Bucket Name',
      extranetEndPoint: 'Extranet End Point',
      location: 'Location',
      storageClass: 'Storage Type',
      region: 'Region',
      accountName:"Account Name",
      name:"OSS Name",
      creationDateString:"Creation Date String",
      displayName:"Display Name",
      intranetEndpoint:"Intranet Endpoint",
      displayId:"Display Id",
      access:"Access",
      defaultEncryption:"Default Encryption",
      objStoreName:'Object Store Name',
      pleaseEnterAccountName: "Please Enter Account Name",
      pleaseEnterObjStoreName: "Please Enter object Store Name",
      // 折线图
      line:{
        StorageSizeBytes:'Storage Size(Bytes)',
        StorageSize:'Storage Size',
        GetAndPutRequestsNumberOfTimes:'Get And Put Requests(Frequency)',
        GetRequestClass:'Get Request Class',
        PutRequestClass:'Put Request Class',
        PublicNetworkOutgoingMeteredTrafficBytes:'Public Network Outgoing Metered Traffic(Bytes)',
        PublicNetworkOutgoingMeteredTraffic:'Public Network Outgoing Metered Traffic',
        CrossRegionReplicationOfIncomingMeteredTrafficBytes:'Cross Region Replication Of Incoming Metered Traffic(Bytes)',
        CrossRegionReplicationOfInboundMeteringFlow:'Cross Region Replication Of Inbound Metering Flow',
        availabilityRequestValidRate:"Availability Request Valid Rate",
        availability :"Availability" ,
        requestValidRate :"Request Valid Rate",
        validRequestCountTotalRequestCount:"Valid Request Count Total Request Count",
        validRequestCount:"Valid Request Count",
        totalRequestCount:"Total Request Count",
        internetcdnsync:"Internetcdnsync",
        internetSend:"Internet Send",
        internetRecv:"Internet Recv",
        intranetSend:"Intranet Send",
        intranetRecv:"Intranet Recv",
        cdnSend:"Cdn Send",
        cdnRecv:"Cdn Recv",
        syncSend:"Sync Send",
        syncRecv:"Sync Recv",
        // tiya
        requestCount:'Request Count',
        receivedBytesCount:'Received Bytes Count',
        sentBytesCount:'Sent Bytes Count',
        objectCount:'Object Count',
        totalByteSeconds:'Total Byte Seconds',
        totalBytes:'Total Bytes'
      }
    },
    // 合规检查
    complianceChecks: {
      addComplianceChecks: 'Add ComplianceChecks',
      updateComplianceChecks: 'Update ComplianceChecks',
      compliance: 'Compliance Checks',
      Details:'Details',
      FilterbyResourceComplianceStatus:'Resource Compliance Status',
      IgnoreConfirmation:'Ignore Confirmation',
      AreyouSureWantToIgnore:'Are you Sure Want To Ignore?',
      Ignore:'Ignore',
      RestoreConfirmation:'Restore Confirmation',
      AreYouSureWantToRestore:'Are You Sure Want To Restore?',
      Restore:'Restore',
      NonCompliant:'Non Compliant',
      Compliance:'Compliance',
      Account:'Account',
      Area:'Area',
      ResourceID:'Resource ID',
      ResourceType:'Resource Type',
      ResourceComplianceStatus:'Resource Compliance Status',
      RuleName:'RuleName',
      Description:'Description',
      Operating:'Operating',
      AddWhitelist:'Add White list',
      PleaseSelectAccount:'Account',
      PleaseSelectRegion:'Region',
      FilterbyComplianceRules:'Compliance Rules',
      ResourceName:'Resource Name',
      SearchbyName:'Name',
      AddWhitelistResources:'Add White List Resources',
      ComplianceRules:'Compliance Rules',
      Overview:'Overview',
      WhiteList:'White List'
    },
    // 日志服务
    logService: {
      logService: 'Log Service',
      logServiceDescription: 'Log Service Description',
      logServiceConfiguration: 'Log Service Configuration',
      projectName: 'Project Name',
      logName: 'Log Name',
      configurationInformation: 'Configuration Information',
      logStoreName: 'Log Store Name',
      pleaseEnterLogStoreName: "Please Enter Log Store Name",
      region: 'Region',
      // 折线图
      line:{
        WriteTrafficByte:'Write Traffic(Byte)',
        WriteTraffic:'Write Traffic',
        ReadFlowByte:'Read Flow(Byte)',
        ReadFlow:'Read Flow',
        NumberOfOperationsCount:'Number Of Operations(Count)',
        NumberOfOperations:'Number Of Operations',
        OriginalDataSizeBytes:'Original Data Size(Bytes)',
        OriginalDataSize:'Original Data Size',
        ServiceStatusCount:'Service Status(Count)',
        ServiceStatus:'Service Status',
        FailedLines:"Failed Lines",
        SumQps:"Sum Qps",
        SuccessdByte:"Successd Byte",
        InflowLine:"Inflow Line",
        ConsumerGroupFallBehind:"Consumer Group Fall Behind"
      }
    },
    // 网络
    network: {
      // CEN
      cen: {
        cen: 'CEN',
        cenDescription: 'CEN Description',
        cenConfiguration: 'CEN Configuration',
        configurationInformation: 'Configuration Information',
        description: 'Description',
        name: 'Name',
        cenId: 'CEN ID',
        // 折线图
        line:{
          RegionalOutflowBandwidthPercentage:'Regional Outflow Bandwidth(%)',
          RegionalOutflowBandwidth:'Regional Outflow Bandwidth',
          GeographicalOutboundBandwidthPercentage:'Geographical Outbound Bandwidth(%)',
          GeographicalOutflowBandwidth:'Geographical Outflow Bandwidth',
          RegionalDelayms:'Regional Delay(ms)',
          RegionalDelay:'Regional Delay'
        }
      },
      // 负载均衡
      loadBalancing: {
        loadBalancing: 'Load Balancing',
        loadBalancingDescription: 'Load Balancing Description',
        loadBalancingConfiguration: 'Load Balancing Configuration',
        configurationInformation: 'Configuration Information',
        instanceIp: 'Instance Ip Address',
        region: 'Region',
        name: 'Name',
        loadbalancerId: 'Load Balancing ID',
        ip: 'IP',
        DNSName: "DNS Name",
        LBType: "Type",
        status: "Status",
        vpcId: 'VPC ID',
        addLBAlarm:"Add Load Balance Alarm",
        editLBAlarm: 'Edit Load Balance Alarm',
        // 折线图
        line:{
          NumberOfAbnormalBackEndECSInstancesCount:'Number Of Abnormal Back End ECS Instances(count)',
          NumberOfAbnormalBackEndECSInstances:'Number Of Abnormal Back End ECS Instances',

          TargetGroupHealthCheckStation:'Target Group Health Check(station)',
          InstancePacket:"Instance Packet",
          InstancePacketRX:'Instance Packet RX',
          InstancePacketTX:'Instance Packet TX',
          InstanceConnection:"Instance Connection",
          InstanceActiveConnection:'Instance Active Connection',
          InstanceInactiveConnection:'Instance Inactive Connection',
          InstanceMaxConnection:'Instance Max Connection',
          InstanceTrafficRTX:"Instance Traffic RTX",
          InstanceTrafficRX:"Instance Traffic RX",
          InstanceTrafficTX:"Instance Traffic TX",
          InstanceNewConnectionCount:"Instance New Connection Count",
          InstanceNewConnection:"Instance New Connection",
          InstanceDropTrafficRTX:"Instance Drop Traffic RTX",
          InstanceDropTrafficRX:"Instance Drop Traffic RX",
          InstanceDropTrafficTX:"Instance Drop Traffic TX",
          InstanceDropTrafficTXBits:"Instance Drop Traffic TX Bits",
          InstanceDropTrafficRXBits:"Instance Drop Traffic RX Bits",
          InstanceDropPacketRTX:"Instance Drop Packet RTX",
          InstanceDropPacketRX:"Instance Drop Packet RX",
          InstanceDropPacketTX:"Instance Drop Packet TX",
          InstanceDropPacketRXCount:"Instance Drop Packet RX Count(Count/s)",
          InstanceDropPacketTXCount:"Instance Drop Packet TX Count(Count/s)",
          InstanceDrops:"Instance Drops(Count/s)",
          InstanceDropConnection:"Instance Drop Connection",
          InstanceQpsCount:"Instance Qps Count(Count/s)",
          InstanceQps:"InstanceQps",
          InstanceQpsUtilizationPercent:"Instance Qps Utilization Percent(%)",
          InstanceQpsUtilization:"InstanceQps Utili zation",
          InstanceNewConnectionUtilizationPercent:"Instance New Connection Utilization Percent(%)",
          InstanceNewConnectionUtilization:"Instance New Connection Utili zation",
          InstanceMaxConnectionUtilizationPercent:"Instance Max Connection Utilization Percent(%)",
          InstanceMaxConnectionUtilization:"Instance Max Connection Utilization",
          InstanceUpstreamRtMs:"Instance Upstream Rt Ms(ms)",
          InstanceUpstreamRt:"Instance Upstream Rt",
          InstanceUpstreamCode:"Instance Upstream Code(Count/Second)",
          InstanceUpstreamCode4xx:"Instance Upstream Code 4xx",
          InstanceUpstreamCode5xx:"Instance Upstream Code 5xx",
          InstanceStatusCode:"Instance Status Code(Count/Second)",
          InstanceStatusCode2xx:"Instance Status Code 2xx",
          InstanceStatusCode3xx:"Instance Status Code 3xx",
          InstanceStatusCode4xx:"Instance Status Code 4xx",
          InstanceStatusCode5xx:"Instance Status Code 5xx",
          InstanceRtms:"Instance Rt ms",
          InstanceRt:"Instance Rt",
          BackendLatencies:"Backend Latencies",
          BackendRequestBytesCount:"Backend Request Bytes Count",
          BackendRequestCount:"Backend Request Count",
          BackendResponseBytesCount:"Backend Response Bytes Count",
          InternalBackendLatencies:"Internal Backend Latencies",
          InternalRequestCount:"Internal Request Count",
          InternalRequestBytesCount:"Internal Request Bytes Count",
          InternalResponseBytesCount:"Internal Response Bytes Count",
          InternalTotalLatencies:"Internal Total Latencies",
          RequestCount:"Request Count",
          ResponseBytesCount:"Response Bytes Count",
          TcpEgressBytesCount:"Tcp Egress Bytes Count",
          TcpEgressPacketsCount:"Tcp Egress Packets Count",
          TcpIngressBytesCount:"Tcp Ingress Bytes Count",
          TcpIngressPacketsCount:"Tcp Ingress Packets Count",
          TcpInternalEgressBytesCount:"Tcp Internal Egress Bytes Count",
          TcpInternalEgressPacketsCount:"Tcp Internal Egress Packets Count",
          TcpInternalIngressBytesCount:"Tcp Internal Ingress Bytes Count",
          TcpInternalIngressPacketsCount:"Tcp Internal Ingress Packets Count",
          TcpClosedConnections:"Tcp Closed Connections",
          TcpNewConnections:"Tcp New Connections",
          UdpEgressBytesCount:"Udp Egress Bytes Count",
          UdpEgressPacketsCount:"Udp Egress Packets Count",
          UdpIngressBytesCount:"Udp Ingress Bytes Count",
          UdpIngressPacketsCount:"Udp Ingress Packets Count",
          UdpInternalEgressBytesCount:"Udp Internal Egress Bytes Count",
          UdpInternalEgressPacketsCount:"Udp Internal Egress Packets Count",
          UdpInternalIngressBytesCount:"Udp Internal Ingress Bytes Count",
          UdpInternalIngressPacketsCount:"Udp Internal Ingress Packets Count",
          UdpClosedConnections:"Udp Closed Connections",
          UdpNewConnections:"Udp New Connections",
        }
      },
      AppGateway: {
        //应用程序网关
        title:"Application Gateways",
        addAppGatewayAlarm:"Add Appilcation Gateway Alert Rule",
        resourceGroup:"Resource Group",
        addLBAlarm: "Add Load Balance Alarm",
        editLBAlarm: 'Edit Load Balance Alarm',
        // 折线图
        line:{
          ThroughputByte:'Throughput(Byte)',
          Throughput:'Throughput',
          NumberOfConnectionsCount:'Number Of Connections(Count)',
          NumberOfConnections:'Number Of Connections'
        }
      },
      AppService: {
        addAppServiceAlertRule: 'Add AppService AlertRule',
        updateAppServiceAlertRule: 'Update AppService AlertRule',
        //应用程序服务
        title: "AppService",
        add: "Add AppService Alert Rule",
        name: "Name",
        status: "Status",
        appType: "Application Type",
        appPlan: "AppService Type",
        resourceGroup: "Resource Group",
        location: "Location",
        subscription: "Subscription",
        description: "AppService Description",
        appConfig: "AppService Configuration",
        subscriptionID: "Subscription ID",
        subscriptionName: "Subscription Name",
        appServiceInfo: "AppService Information",
        time:"Time",
        // 折线图
        line:{
          CPUTimeseconds:'CPU Time(s)',
          MemorySetbytes:'Memory Set(Bytes)',
          MemorySet:'Memory Set',
          ResponseTimeseconds:'Response Time(s)',
          ResponseTime:'Response Time'
        }
      },
 //nat网关
 nat:{
  nat:"Nat",
  natList:"NatList",
  region:"Region",
  name:"Name",
  natGatewayId:"Nat Gateway Id",
  state:"State",
  publicIp:"Public Ip",
  privateIp:"Private Ip",
  vpcId:"VPC",
  createTime:"Create Time",
  natConfig:"Nat Config",
  natInformation:"Nat Information",
  line:{
    SessionActiveLimitDropConnectionCount:"Session Active Limit Drop Connection Count",
    SessionActiveConnectionCount:"Session Active Connection Count",
    SessionLimitDropConnectionCount:"Session Limit Drop Connection Count",
    SessionNewLimitDropConnectionCount:"Session New Limit Drop Connection Count",
    SessionNewConnectionCountS:"Session New Connection CountS",
    SessionNewLimitDropConnectionCountS:"Session New Limit Drop Connection CountS",
    SessionActiveNewConnectionWaterLever:"Session Active New Connection Water Lever",
    SessionActiveConnectionWaterLever:"Session Active Connection Water Lever",
    SessionNewConnectionWaterLever:"Session New Connection Water Lever",
    BWRateInFromOutToInsideBps:"BW Rate In From Out To Inside Bps",
    BWRateInFromOutsideBps:"BW Rate In From Outside Bps",
    BWRateOutToInsideBps:"BW Rate Out To Inside Bps",
    BytesInFromOutOutToInsideByte:"Bytes In From Out Out To Inside Byte",
    BytesInFromOutsideByte:"Bytes In From Outside Byte",
    BytesOutToInsideByte:"Bytes Out To Inside Byte",
    PPSRateInFromOutOutToInsideCount:"PPSRate In From Out Out To Inside Count",
    PPSRateInFromOutsideCount:"PPSRate In From Outside Count",
    PPSRateOutToInsideCount:"PPSRate Out To Inside Count",
    PacketsInFromOutOutToInsideCount:"Packets In From Out Out To Inside Count",
    PacketsInFromOutsideCount:"Packets In From Outside Count",
    PacketsOutToInsideCount:"Packets Out To Inside Count",
    BWRateInFromInOutToOutsideBps:"BWRate In From In Out To Outside Bps",
    BWRateInFromInsideBps:"BWRate In From Inside Bps",
    BWRateOutToOutsideBps:"BWRate Out To Out side Bps",
    BytesInFromInOutToOutsideByte:"Bytes In From In Out To Outside Byte）",
    BytesInFromInsideByte:"Bytes In From Inside Byte",
    BytesOutToOutsideByte:"Bytes Out To Outside Byte",
    PPSRateInFromInOutToOutsideCountS:"PPSRate In From In Out To Outside CountS",
    PPSRateInFromInsideCountS:"PPSRate In From Inside CountS",
    PPSRateOutToOutsideCountS:"PPSRate Out To Outside CountS",
    PacketsInFromInOutToOutsideCount:"Packets In From In Out To Outside Count",
    PacketsInFromInsideCount:"Packets In From Inside Count",
    PacketsOutToOutsideCount:"Packets Out To Outside Count "
  }
  }
    },
     //SLS
     sls:{
      sls:"Sls",
      slsList:"Sls List",
    },
    //autoscaling
    autoscaling:{
      autoscaling:"Autoscaling",
      autoscalingList:"Autoscaling List",
      accountIdString:"Account Id String",
      accountName:"Account Name",
      scalingGroupId:"Scaling Group Id",
      scalingGroupName:"Scaling Group Name",
      groupType:"Group Type",
      vpcId:"VPC ID",
      totalInstanceCount:"Total Instance Count",
      lifecycleState:"Lifecycle State",
      minSize:"Min Size",
      maxSize:"Max Size",
      scalingPolicy:"Scaling Policy",
      healthCheckType:"Health Check Type",
      autoscalingConfig:"Autoscaling Config",
      autoscalingInformation:"Autoscaling Information",
      line:{
        MaxInstanceCount:"MaxInstance Count",
        MinInstanceCount:"MinInstance Count",
        PendingInstanceCount:"Pending Instance Count",
        RemovingInstanceCount:"Removing Instance Count",
        RunningInstanceCount:"Running Instance Count",
        TotalInstanceCount:"Total Instance Count"
      }
    },
    // Redshift
    redshift: {
      addRedshiftAlarm: 'Add Redshift Alarm',
      editRedshiftAlarm: 'Edit Redshift Alarm',
      cluster: 'Cluster',
      accountName: "Account Name",
      nodeType: 'Cluster Type',
      nodeSize: 'Node Size',
      redshiftList: 'Redshift List',
      redshiftName: "Redshift Name",
    },
    // elasticSearch
    elasticSearch: {
      addEsAlarm: 'Add Elastic Search Alarm',
      editEsAlarm: 'Edit Elastic Search Alarm',
      esDomain: "ES Domain",
      elasticSearchList: 'Elastic Search List',
      filterByEsDomainName: 'ES Domain Name',
      clusterStatus:'Cluster Status',
      blockWriteRequest:'Block Write Request',
      numberOfNodes:'Number Of Nodes',
      automaticSnapshotFailed:'Automatic Snapshot Failed',
      kMSKeyError:'KMSKey Error',
      kMSKeyCannotBeAccessed:'KMSKey Cannot Be Accessed',
      dataNodeCPUUsage:'DataNode CPU Usage',
      dataNodeJVMMemoryPressure:'DataNode JVM Memory Pressure',
      cPUUsageOfTheMasterNode:'CPU Usage Of The Master Node',
      JVMMemoryPressureOnTheMasterNode:'JVM Memory Pressure On The Master Node',
      dataNodeRemainingStorageSpace:'DataNode Remaining Storage Space(%)',
      green:'Green',
      yellow:'Yellow',
      red:'Red'
    },
    // redis
    redis: {
      addRedisAlarm: 'Add Redis Alarm',
      editRedisAlarm: 'Edit Redis Alarm',
      redisList: 'Redis List',
      filterByCacheClusterId: 'Filter By CacheClusterId',
      redisDescription:'Redis Description',
      redisConfig:'Redis Config',
      redisInfo:'Redis Info',
      cacheClusterId:'cacheClusterId',
      currConnectionAmount:'CurrConnection(Quantity)',
      currConnection:'CurrConnection',
      bytesUsedForCacheByte:'BytesUsedForCache(Byte)',
      bytesUsedForCache:'BytesUsedForCache'
    },
    FileStore:{
      title: 'Title',
      filterByGFilestoreName: 'Filter By GFilestore Name',
      accountName:'Account Name',
      accountIdString:'Account Id String',
      region:'Region',
      name:'Name',
      description:'Description',
      state:'State',
      capacity:'Capacity',
      tier:'Tier',
      projectId:'ProjectId',
      filestoreCreatetime:'GCP Filestore Createtime'
    },
    // 云用户
    cloudUser: {
      title:"CloudUser",
      cloudUserList:"CloudUser List",
      addCloudUserAlarm: 'Add Cloud User Alarm',
      editCloudUserAlarm: 'Edit Cloud User Alarm',
      cloudUserName: 'cloud user'
    },
    // 邮箱
    mailbox: {
      title:"Mailbox",
      addMailBoxAlarm: 'Add Mailbox Alarm',
      editMailBoxAlarm: 'Edit Mailbox Alarm',
      monitoringMailBox: 'Monitoring MailBox'
    },
    // 网站健康状态
    websiteHealthStatus: {
      title:"Website Health Status",
      addWebsiteHealthStatusAlarm: 'Add Website Health Status Alarm',
      editWebsiteHealthStatusAlarm: 'Edit Website Health Status Alarm',
      host: 'Host',
      port: 'Port',
      timeout: 'Timeout'
    },
    // 报警规则公用项
    common: {
      dynamicHeader:'Dynamic Header',
      alertContact: 'Contact',
      alertContactGroup: 'Contact Group',
      weChatTemplate: 'WeChat Template',
      phoneTemplate: 'Phone Template',
      emailTemplate: 'Email Template',
      monitoringTime: 'Monitoring Time',
      delayAlarm: 'Delay Alarm',
      alarmType: 'AlarmType',
      pleaseSelect: 'Please Select',
      unit: 'Unit',
      threshold: 'Threshold',
      continuous: 'Continuous',
      volatility: 'Volatility',
      checkCycle: 'Check Cycle',
      tips: 'Due to the latency of utilization and coverage, the detection time is pushed forward 2 days from the current time. For example, if the current detection period is 2023-11-20 and the detection period is 30 days, the detection period ranges from 2023.10.18 to 2023.11.18',
      tooltips: 'The detection period is nearly 30 days',
      cycle: 'Cycle',
      sign: 'Sign',
      statisticsValue: 'StatisticsValue',
      ok: 'OK',
      addAlarm: 'Submit',
      addWhitelist: 'Add Whitelist',
      search: 'Search',
      nextStep: 'Next Step',
      lastStep: 'Last Step',
      cancel: 'Cancel',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      details: 'Details',
      deleteConfirmation: 'Delete Confirmation',
      sureDelete: 'Are you sure you want to delete',
      sureDeletes: 'Are you sure you want to delete',
      sureRunImmediately:"Are you sure to run immediately ",
      allWarningRules: 'All the relevant warning rules',
      createdTime: 'Created Time',
      monitorMessage: 'Monitor Message',
      monitorItems: 'Monitor Items',
      viewMonitoringOverview: 'View Monitoring Overview',
      viewForecastMonitoringOverview: 'View Forecast Monitoring Overview',
      alertRule: 'Alert Rule',
      untreated: 'UntreatedTicket',
      viewAlarmRules: 'View Alarm Rules',
      tags: 'Tags',
      count: ' Count',
      what: ' ',
      seriousProblems: ' Serious Problems',
      hostDescription: 'Host Description',
      allRegion: 'All Regions',
      monitoringSummary: 'Monitoring Summary',
      refresh: 'Refresh',
      alertRuleName: 'Alarm Name',
      status: 'Status',
      monitorIndex: 'Monitor Index',
      contact: 'Contact',
      scanType: 'Type',
      delayType: 'Delay Type',
      delayCountdown: 'Delay Countdown(H)',
      accountName: 'Account Name',
      account: 'Account',
      accountType: 'Account Type',
      region: 'Region',
      accountGroupName: 'Account Group Name',
      billingType: 'Billing Type',
      alertRuleDesc: 'Alert Rule Desc',
      resourceType: 'Resource Type',
      allResourceType: 'All Resource Type',
      back: 'Back',
      pleaseSelectCompany: 'please Select Company',
      pleaseSelectRegions: 'please Select Regions',
      all: 'All Data',
      allSelected: 'All Selected',
      filterByAlertRuleName: 'Alert Rule Name',
      filterNatGatewayId: 'Nat Gateway ID',
      filterOssName:"Oss Name",
      filterByVpcName:"Vpc Name",
      filterByAccountType: 'Account Type',
      filterByAccountName: 'Account Name',
      filterByNatGatewayId:"NatGateway Id",
      filterByInstanceId: 'Instance ID',
      filterByInstanceName: 'Instance Name',
      filterByIpAddress: 'IP Address',
      filterByTagKey: 'Tag Key',
      filterByTableName: 'Table Name',
      filterByScalingGroupName:"Scaling Group Name",
      filterByProjectName:"Project Name",
      pleaseSelectAccount: 'Account',
      pleaseSelectStatus: 'Status',
      pleaseSelectCategory: 'Category',
      pleaseSelectDelayType: 'Delay Type',
      operationLog: 'Log',
      pleaseInputValue: 'Value',
      ruleName: 'Rule Name',
      monitoringMethod: 'Monitoring Method',
      ruleDescription: 'Rule Description',
      continuousCycle: 'Continuous Cycle',
      statisticsCount: 'Statistics Count',
      symbol: 'Symbol',
      minimum: 'Minimum',
      max: 'Max',
      logGroupName: 'Log Group Name',
      contactPerson: 'Contact Person',
      contactType: 'Contact Type',
      notificationObject: 'Notification Object',
      contactGroup: 'Contact Group',
      noticeType: 'Notice Type',
      alarmDelay: 'Alarm Delay',
      monitorPeriod: 'Monitor Period',
      emailModal: 'Email Template',
      wechatModal: 'Wechat Template',
      phoneModal: 'Phone Template',
      approvalFlow: 'Approval Flow',
      cloudPlatform: 'Cloud Platform',
      standardValue: 'Standard Value',
      routineMonitoring: 'Routine Monitoring',
      intervalMonitoring: 'Interval Monitoring',
      warning:'Warning',
      wechatTip:'There is currently no WeChat contact, please cancel the WeChat notification channel and continue!',
      phoneTip:'There is currently no phone contact, please cancel the Phone notification channel and continue!',
      enable: 'Enable',
      disable: 'Disable',
      manual: 'Manual',
      automatic: 'Automatic',
      fiveMinutes:'Five Minutes',
      fifteenMinutes:'Fifteen Minutes',
      oneHour:'One Hour',
      sixHour:'Six Hour',
      oneDay:'One Day',
      Empty:'Empty',
      SelectionPeriod:'Selection Period',
      close:'Close',
      enterpriseWeChatRobotURL:'Enterprise WeChat Robot URL',
      publicIp:"PublicIp",
      resourceSyncLog: "resourceSyncLog"
    },
    // 存储网关
    storagegateway: {
      storagegateway:'Storage Gateway',
      storagegatewayList:'Storage Gateway List',
      addAlertRule:'Add Storage Gateway Alert Rule',
      filterByStorageGatewayName:'Filer by Storage Gateway Name',
      storageGatewayName:'Storage Gateway Name',
      addStorageGatewayAlarm:'Add Storage Gateway Alarm',
      storageGatewayDetail:'Storage Gateway Detail' ,
      storageGatewayConfig:'Storage Gateway Config',
      storageGatewayInfo:'Storage Gateway Info',
      editStorageGatewayAlarm: 'Edit Storage Gateway Alert Rule'
    }
  },
  // 实例列表
  instance_list: {
    swireInstanceList: 'Swire Instance List',
    environment: 'Environment',
    instanceName: 'Instance Name',
    usageDetail: 'Usage Detail',
    availableZone: 'Available Zone',
    privateIP: 'Private IP',
    CPUNumber: 'CPU Number',
    mem: 'Mem(GB)',
    disk: 'Disk(GB)',
    project: 'Project',
    business: 'Business',
    owner1: 'Owner1',
    owner2: 'Owner2',
    os: 'OS',
    env: 'Env',
    billingType: 'Billing Type',
    selectByEnvironment: 'Environment',
    selectByDate: 'Date'
  },
  // 报警联系人
  alarm_contact: {
    allType: 'All Type',
    contact: 'Contact',
    contactGroup: 'Contact Group',
    selectByCompany: 'Company',
    selectByName: 'Name',
    alarmContact: 'Alarm Contact',
    alarmContactSearchKeyPlaceholder: 'Name',
    addAlarmContact: 'Add Alarm Contact',
    companyName: 'Company Name',
    name: 'Name',
    dept: 'Dept',
    position: 'Position',
    monitorModule: 'Monitor Module',
    phone:"Phone",
    email: 'Email',
    wechat: 'Wechat',
    defaultContact: 'Default Contact',
    alarmContactReplacement: 'Alarm Contact Replacement',
    del: 'Delete',
    addContact: "Add Contact Group",
    contactGroupName: "Contact Group Name",
    selectByContactGroupName: "ContactGroup Name",
    default: "Is Default",
    description: "Description",
    contactGroupConfig: "Configuration",
    operationLog: "Log",
    replace: "Replace",
    replaceTip: "Replace the alarm rules of the current contact with the new contact!",
    bindingStatus: "Binding Status",
    personalWeChat: "Personal WeChat",
    yes: "Yes",
    no: "No",
    unBind: "Un Bind",
    isBinding:'Is Binding',
    editContact: "Edit Contact",
    contactConfiguration: "Contact Configuration",
    enterpriseWechatRobot: "Enterprise Wechat Robot",
    searchByRobotName: "Robot Name",
    add: "Add",
    edit: "Edit",
    robotName: "Robot Name"
  },
  // 定时开关机
  schedule_instance_config: {
    start:'Start',
    pause:'Pause',
    close:'Close',
    exception:'Exception',
    ip: 'IP',
    instanceName: 'Instance Name',
    AWSType: "AWS Resource Type",
    instanceUsage: 'Instance Usage',
    instanceStatus: 'Instance Status',
    isWorkDay: 'IsWorkDay',
    scheduleOpenInstanceTime: 'Open Instance Time',
    scheduleCloseInstanceTime: 'Close Instance Time',
    isException: 'IsException',
    exceptionStartDate: 'Exception StartDate',
    exceptionEndDate: 'Exception EndDate',
    exceptionStartTime: 'Exception StartTime',
    exceptionEndTime: 'ExceptionEndTime',
    hasScheduledTask: 'Has Scheduled Task',
    timeSwitch: 'Time Switch',
    search: 'Search',
    timeSwitchTask: 'Time Switch Task',
    selectByCompany: 'Company',
    selectByIp: 'Ip',
    add: 'Add',
    addSystemTask: 'Add System Task',
    editSystemTask: 'Edit System Task',
    status: 'Status',
    approvalFlow: 'Approval Flow',
    instance: 'Instance',
    reason: 'Reason',
    yes: 'Yes',
    no: 'No',
    workDay: 'Work Day',
    everyDay: 'Every Day',
    virtualHost: 'Virtual Host',
    virtualDesktop: 'Virtual Desktop',
    del: 'Delete',
    performType:'Perform Type'
  },
  audit_task: {
    auditTask: 'Audit Task',
    ip: 'IP',
    operator: 'Operator',
    auditor: 'Auditor',
    auditStatus: 'Audit Status',
    operationType: 'Operation Type',
    createdTime: 'Created Time',
    denialReason: 'Denial Reason',
  },
  configuration_management: {
    // 邮箱配置管理
    mailbox_management: {
      email: "Monitor Marilbox",
      monitorMailboxConfiguration: "Monitor Mailbox Configuration",
      processEmails: "Subject of Pending Email",
      emailSubject: 'Email Subject',
      addEmail: 'Add Email',
      editEmail: 'Edit Email',
      addEmailSubjectKeyword: 'Add Email Subject Keyword',
      editEmailSubjectKeyword: 'Edit Email Subject Keyword',
      emailSubjectKeyword: 'Email Subject Keyword',
      company: 'Company',
      emailName: 'Email Name',
      host: 'Host',
      port: 'Port',
      userName: 'User Name',
      password: 'Password',
      describe: 'Describe',
      queryByKeyWord: 'Key Word',
    },
    // 预留实例购买
    reserved_instance_purchase : {
      title: 'Reserve Instance',
      riFamily: "RI Family",
      size: "Size",
    },
    // schedules
    schedules: {
      title: "Schedule",
      addSchedule: "Add Schedule",
      editSchedule: "Edit Schedule",
      name: "Name",
      repetition: "Repetition",
      frequency: "Frequency",
      enableWeekdays: "Enable Week Days",
      start: "Start",
      end: "End",
      startFor: "To Enable the",
      describe: "Describe",
      minute: "Minute",
      hour: "Hour",
      day: "Day",
      week: "Week",
      month: "Month",
      Monday: "Monday",
      Tuesday: "Tuesday",
      Wednesday: "Wednesday",
      Thursday: "Thursday",
      Friday: "Friday",
      Saturday: "Saturday",
      Sunday: "Sunday",
      queryByName: "Name",
    },
    // System Task
    system_task: {
      addSystemTask: 'Add System Task',
      configureSystemTask: 'System Task',
      taskID: 'Task ID',
      beanName: 'Bean Name',
      methodName: 'Method Name',
      methodParameter: 'Method Parameter',
      cronExpressioin: 'cron Expressioin',
      note: 'Note',
      ok: 'OK',
      paused: 'Paused',
    },
    // Customized Alarm Config
    customized_alarm_config: {
      customizedAlarmConfig: 'Customized Alarm',
      listOfAlarmRules: 'List Of Alarm Rules',
      version: 'Version',
      isAutoDelayEnroll: 'Is Auto Delay Enroll',
      addVolume: "Add Volumes",
      checkAll: "Check All",
      checkTheListOfAlarmRules: "Check the list of alarm rules",
      setUpAUniversalAIAlarmHandlingProcess: 'Set up a universal AI alarm handling process',
      defaultApprovalFlow: 'Default Approval Flow',
      alarmValidityPeriod: 'Alarm Validity Period (Min)',
      alarmValidityPeriodSecond: 'Alarm Validity Period (Second)',
      noticeType: 'Notice Type',
      exceptionResources: "Exception Resources",
      AIMonitoringAlarm: 'AI monitoring alarm',
      AIMonitorsTheAlarmStatus: 'AI monitors the alarm status',
      editAIAlarmProcess: 'Edit AI alarm process',
      whetherToEnableEmailNotifications: 'Whether to enable email notifications',
      editGeneralAIAlarmProcess: 'Edit general AI alarm process',
      pleaseEnterTheProcessContent: 'Please enter the process content',
      identification: 'Identification',
      pleaseConfigureTheNotificationTemplate: 'Please configure the notification template',
      configureSeparateAIAlarmProcess: 'Configure separate AI alarm process',
      recipient: 'Recipient',
      usingResources:'Using Resources',
      alertRuleDesc:'AlertRule Desc',
      delayName:'Delay Name',
      alarmDelayCountdown:'AlarmDelay Countdown'
    },
    // Default Alarm Config
    default_alarm_config: {
      defaultAlarmConfig: 'Default Alarm',
      addDefaultAlarmConfig: 'Add Default Alarm Config',
      editDefaultAlarmConfig: 'Edit Default Alarm Config',
      addAlarm: 'Add  Alarm ',
      cloudPlatform: 'Cloud Platform',
    },
    //配置管理通用
    common: {
      all: 'All',
      cloudType: 'Cloud Type',
      sequenceId: 'Sequence Id',
      accountType: 'Account Type',
      cycle: 'Cycle',
      continuous: 'Continuous',
      statisticsValue: 'Statistics Value',
      statisticsCount: 'Count',
      resourceType: 'Resource Type',
      sign: 'Sign',
      threshold: 'Threshold',
      unit: 'Unit',
      priority: 'Priority',
      standardValues: 'Standard Value',
      type: "Type",
      ruleDescription: "Rule Description",
      monitorModule: 'Monitor Module',
      logGroupName: 'Log Group Name',
      monitorPeriod: 'Monitoring Period',
      alarmWayList: 'Alarm Way',
      isAutoDelayEnrollTypeList: 'Whether To Register Automatic Delay',
      pleaseSelectCompany: 'Please Select Company',
      operationLog: 'Log',
      deleteButton: 'Delete',
      pleaseSelectStartTime: 'Please Select Start Time',
      pleaseSelectEndTime: 'Please Select End Time',
      selectButton: 'Select',
      changeField: 'Change Field',
      originalValue: 'Original Value',
      newValue: 'New Value',
      operator: 'Operator',
      operatingTime: 'Operating Time',
      pleaseSelect: 'Please Select',
      save: "Save",
    }
  },
  permission_configuration_management: {
    //权限模块通用
    common:{
      all: 'All',
      pleaseInput:'Please Input',
      pleaseSelect:'Please Select',
      edit:'Edit',
      enable: 'Enable',
      disable: 'Disable',
      cancel:'Cancel',
      confirm:'Confirm',
      delete:'Delete',
      operationLog: 'Log',
      pleaseSelectCompany:'Company',
    },
    // Permission
    permission:{
      permissionOverview:'Permission Overview',
      permissions:'Permissions',
      authorized:'Authorized',
      templateName:'Policy Type'
    },
    // Account
    account: {
      cancel:'Cancel',
      confirm:'Confirm',
      delete:'Delete',
      elk:'ELK',
      protogenesis:'Protogenesis',
      overseas:'Overseas',
      china:'China',
      all:'All',
      pleaseSelectCompany:'Company',
      checkByAccountName:'AccountName',
      subscriptionId: 'Subscription Id',
      subscriptionName: 'Subscription Name',
      accessKeyID: 'Access Key',
      secretAccessKey: 'Secret Access',
      roleSessionName: 'Role Session Name',
      roleArn: 'Role Arn',
      externalId: 'External Id',
      scanResources: 'Scan Resources',
      account: 'Account',
      company: 'Company',
      addAccount: 'Add Account',
      editAccount: 'Edit Account',
      searchNewResource: 'Search New Resource',
      accountName: 'Account Name',
      scanResource: 'Scan Resource',
      accountType: 'Account Type',
      accountId: 'Account Id',
      area: 'Area',
      region: 'Region',
      authType: 'Auth Type',
      dataSource: 'Data Source',
      accountRegister: 'Account Register',
      labelScanInterval: 'Label Scan Interval',
      contactType: 'Contact Type',
      contact: 'Contact',
      contactGroup: 'Contact Group',
      isCoverDefault: 'Scan for resources that already have custom alerts',
      immediatelyScan: 'Immediately Scan',
      update: 'Update',
      operationLog: 'Log',
      enable: 'Enable',
      disable: 'Disable'
    },
    // 注册
    register:{
      UserName:'Username',
      FullName:'Fullname',
      Company:'Company',
      Department:'Department',
      Position:'Position',
      Mailbox:'Mailbox',
      Password:'Password',
      ConfirmPassword:'Confirm Password',
      Register:'Register',
      ExistingAccountLogin:'Existing Account Login',
      SendTheVerificationCode:'Send Code',
      VerificationCode:'Verification Code',
      NextStep:'Next Step',
      ResetPassword:'Reset Password',
      Warning:'Warning',
      ResetTip:'The password has been entered incorrectly for 5 times, and the password change function has been locked. Please visit this function after 1 hour!',
      Cancel:'Cancel',
      Reset:'Reset'
    },
    smsLogin:{
      telPhone:'Phone Number',
      SMSAuthenticationLogin:'SMS Authentication Login',
      plaTelPhone:'Please enter your mobile number',
      rightTelPhone:'Please enter the correct mobile number',
      plaVerificationCode:'Please enter the verification code',
      getVerificationCode:'Get verification code',
      surplusTime:'Remaining time',
      Reacquire:'Reacquire',
      verificationCode:'Verification Code',
      product:'product',
      subscribe:'subscribe',
      doc:'doc',
      TrialVersion:'Trial Version',
      trialVersionDesc:'Tailor made for team collaboration to improve collaboration efficiency',
      function:'function',
      Dashboard:'Dashboard',
      CaseWorkOrderSystem:'Case Work Order System',
      CMDBFunctionSomeResources:'CMDB function (some resources)',
      ResourceAlarmManagement:'Resource Alarm Management(some resources)',

      AlarmContact:'Alarm Contact',

      BillManagement:'Bill Management（AWS）',

      ReservedInstances:'Reserved Instances',

      PermissionConfigurationManagement:'Permission Configuration Management',

      OfficialEdition:'Official Edition',
      trialVersionDescOfficial:'Full life cycle coverage of product development',
      OfficialFunction:'Full functionality of the trial version, and',
      InstrumentClusterEnhanced:'Instrument cluster [enhanced]',

      ResourceAlarmManagementEnhancedVersion:'Resource alarm management [enhanced version]',

      AlarmContact:'Alarm Contact',

      TimingSwitch:'Timing Switch',

      ApprovalProcess:'Approval Process',

      BillManagementEnhancedVersion:'Bill Service [enhanced version]',

      PachEasy:'PachEasy',

      ConfigurationManagementEnhanced:'Configuration management [enhanced]',

      IntelligentMonitoring:'Intelligent Monitoring',
      FreeTrial:'Free Trial',
      applyTrial:'Apply Trial',
      UserManual:'User Manual',
      QuickStartGuide:'Quick Start Guide',
      ComingSoon:'Coming Soon...',
      adminGuide:'Admin Guide',
      ResourceLabelManagement:'Resource Label Management',
    },
    // User
    user: {
      newPassword:'New Password',
      currentPassword:'Current Password',
      resetPassword:'Reset Password',
      enable: 'Enable',
      disable: 'Disable',
      offLine:'off-line',
      onLine:'Online',
      checkByUserName:'UserName',
      pleaseSelectCompany:'Company',
      all:'All',
      confirmPassword: 'Confirm Password',
      password: 'Password',
      addUser: 'Add User',
      editUser: 'Edit User',
      userManagement: 'User Management',
      userName: 'User Name',
      companyName: 'Company Name',
      email: 'Email',
      fullName: 'Full name',
      department: 'Department',
      position: 'Position',
      role: 'Role',
      loginStatus: 'Login',
      accountStatus: 'Active',
      SMSVerification:'Enable SMS Verification',
      SMSVerificationStatus:'Enable SMS Verification Status',
    },
    // Role
    role: {
      editRole:'Edit Role',
      companyName: 'Company Name',
      roleManagement: 'Role Management',
      addRole: 'Add Role',
      roleName: 'Role Name',
      menuData: 'Menu Permissions',
      remark: 'Remark',
      checkByRoleName:'Role Name',
    },
    // Group
    group: {
      companyName:'Company Name',
      checkByVirtualDesktopID:'Virtual Desktop ID',
      addVirtualDesktop:'Add Virtual Desktop',
      virtualDesktopID:'Virtual Desktop ID',
      databaseEngine:'Database Engine',
      cloudPlatform:'Cloud Platform',
      addDatabase:'Add Database',
      status:'Status',
      encryption:'Encryption',
      readingSpeed:'Reading Speed',
      type:'Type',
      deviceName:'Device Name',
      name:'Name',
      volumeID:'Volume ID',
      addVolume:'Add Volume',
      checkByVolumeId:'Volume Id',
      tags:'Tag',
      privateIP:'Private IP',
      region: "Region",
      instanceName: "Instance Name",
      instanceID: "Instance ID",
      instanceType: "Instance Type",
      diskStorage: "Disk Storage",
      addInstance:'Add Instance',
      checkByPrivateIP:'Private IP',
      checkByInstanceId:'Instance Id',
      checkByAccountType:'Account Type',
      checkByAccountName:'Account Name',
      checkByStorageGatewayId:'Storage Gateway Id',
      addStorageGateway:'Add Storage Gateway',
      accountType: 'Account Type',
      accountId: 'Account ID',
      accountName:'Account Name',
      addAccount:'Add Account',
      backGroup:'Back Group',
      addUser:'Add User',
      virtualDesktop:'Virtual Desktop',
      database:'Database',
      disks:"Disks",
      instance:'Instance',
      account:'Account',
      user:'User',
      accessConfiguration:'Access configuration',
      groupManagement: 'Group Management',
      addGroup: 'Add Group',
      configPermission: 'Config Permission',
      groupName: 'Group Name',
      checkByGroupName:'GroupName',
      storageGateway:'Storage Gateway',
      storageGatewayID:'Storage Gateway ID',
      storageGatewayName:'Storage Gateway Name',
    },
  },
  // 通用
  common: {
    // 操作
    operation: 'Operation',
    operationLog: 'Log',
    addAlarm: 'Submit',
    editAlarm: 'OK',
    export: 'Export',
    exportInstanceAlarmRule: 'Export Instance Alarm Rule',
    exportRDSAlarmRule: 'Export RDS Alarm Rule',
    exportMetricsStatistics: 'Export Metrics Stat',
    exportStatistics: 'Export Statistics',
    del: 'Delete',
    edit: 'Edit',
    login: 'Login',
    register: 'Register',
    activate: 'Activate',
    inActivate: 'InActivate',
    note: 'Note',
    ok: 'OK',
    configure: 'Configure',
    forgetPassword: 'Forget Password',
    changePassword: 'Change Password',
    userName: 'Username',
    password: 'Password',
    submit: 'Submit',
    determine: 'Determine',
    singleAccount: 'Single Account',
    accountGroup: 'Account Group',
    noData:'No Data',
    notice:'Notice',
    noticeContent:'You Have A New To-Do List',
    yes:'Yes',
    no:'No'
  },
   //备份计划
   backPlan:{
    backPlan:"Back Plan",
    addBackPlanAlarm:"Add Back Plan Alarm",
    backPlanList:"Back Plan List",
    accountTypeName:"Account Type Name",
    accountName:"Account Name",
    backupPlanId:"Backup Plan Id",
    backupPlanName:"Backup Plan Name",
    creationDate:"Creation Date",
    region:"Region",
  },
  // 操作日志
  operation_log: {
    operationLog: "Log",
    changeField: "Change Field",
    operationMonitorModuleName: "Operation Monitor Module Name",
    operationFieldName: "Operation Field Name",
    operationOriginValue: "Operation Origin Value",
    operationNewValue: "Operation New Value",
    createdBy: "Created By",
    search: "Search",
    pleaseSelectStartTime: "Start Time",
    pleaseSelectEndTime: "End Time",
    createdTime: "Created Time"
  },
  patch_management: {
    // 补丁监视器
    patch_monitor: {
      patchMonitor: 'PatchMonitor',
      awsSSMOverview: 'Overview',
      instanceType: 'Instance Type',
      patchedInstancesByOS: 'Patched Instances By OS',
      patchedInstance: 'Patched Instance',
      id: 'Id',
      name: 'Name',
      missingCount: 'Missing Count',
      installedCount: 'Installed Count',
      installedOtherCount: 'Installed Other Count',
      notApplicableCount: 'Not Applicable Count',
      notPatchedInstances: 'Not-Patched Instances'
    },
    //补丁策略
    patch_policy: {
      deletePolicy:"Delete Policy",
      runImmediately:"Run Immediately",
      start:"Start",
      close:"Close",
      active:"Active",
      inactive:"Inactive",
      addPolicy:"Add Policy",
      editPolicy:"Edit Policy",
      name:"Name",
      policyName: "Policy Name",
      account:"Account",
      region:"Region",
      queryByRegion:"Region",
      state:"State",
      remindTime:"Remind Time",
      contactType:"Contact Type",
      contactPerson:"Contact Person",
      contactGroup:"Contact Group",
      approvalFlow:"Approval Flow",
      schedule:"Schedule",
      description:"Description",
      cancel:"Cancel",
      confirm:"Confirm",
      submit:"Submit",
      queryByName:"Name",
      queryByPolicyName: "Query By Policy Name",
      patchDetail:"Patch Detail",
      releaseDate:"Release Date",
      title:"Title",
      vendor:"Vendor",
      productFamily:"Product Family",
      product:"Product",
      classification:"Classification",
      severity:"Severity",
      number:"Number",
      language:"Language",
      patchBaselineDetail:"Patch Baseline Detail",
      baselineId:"Baseline ID",
      baselineName:"Baseline Name",
      os:"Operation System",
      defaultBaseline:"Default Baseline",
      patchGroup:"Patch Group",
      createdDate:"Created Date",
      modifiedDate:"Modified Date",
      queryByAccount:"Account",
      queryBySeverity:"Severity",
      search:"Search",
      queryByOS:"OS",
      patchBaseline:"Patch Baseline",
      patch:"Patch",
      selectAll:"Select All",
      priority: "Priority",
      addPatchBaseline:"Add Patch Baseline",
      editPatchBaseline:"Edit Patch Baseline",
      add:"Add",
      edit:"Edit",
      yes:"Yes",
      no:"No",
      CommandParameters:"Command Parameters",
      Operating:"Operating",
      SnapshotId:"Snapshot Id",
      InstallationCoverageList:"Installation CoverageList",
      WhetherToBackup:"Whether To Backup",
      InAdvance:"InAdvance",
      MinuteBackup:"Minute Backup",
      WhetherTheBackupFailsToContinue:"Whether The BackupFails To Continue",
      BackupRetention:"Backup Retention",
      Day:"Day",
      Aims:"Aims",
      SpecifyTargetMethod:"Specify Target Method",
      SpecifyLabel:"Specify Label",
      ManuallySelectInstance:"Manually Select Instance",
      KeyUpToCharacters:"Key (up to 128 characters)",
      ValueUpToCharacters:"Value (up to 256 characters)",
      Delete:"Delete",
      AddTag:"AddTag",
      OtherParameters:"Other Parameters",
      Comment:"Comment",
      TimeoutSeconds:"Timeout (seconds)",
      OutputOptions:"Output Options",
      Tip:"Write Command Output To Amazon S3 Bucket",
      EnableBucketWriting:"Enable S3 Bucket Writing",
      WriteCommandOutputToAmazonCloudWatchLog:"Write Command Output To Amazon CloudWatch Log",
      CloudWatchOutput:"CloudWatch Output",
      TargetInstance:"Target Instance",
      QuerybyInstanceID:"Instance ID",
      InstanceID:"Instance ID",
      ProxyVersion:"Proxy Version",
      status:"Status",
      AvailableArea:"Available Area",
      platform:"Platform",
      S3BucketName:"S3 Bucket Name",
      S3KeyPrefixOptional:"S3 Key Prefix-Optional",
      LogGroupNameRequired:"Log Group Name-Required",
      save:"Save",
      //Input Validation
      inputValidation: {
        requiredAccount: "Please Select Account",
        requiredRegion: "Please Select Region",
      },

    }
  },
  satisfaction: {
    // 满意度
    title: "Satisfaction",
    search: "Search",
    ticketID: "Ticket ID",
    summary: "Summary",
    initiator: "Initiator",
    ticketCategory: "Ticket Category",
    functionCategory: "Function Category",
    priority: "Priority",
    status: "Status",
    finishTime: "Finish Time",
    satisfaction: "Satisfaction",
    operation: "Operation",
    detail: "Detail",
    comment: "Comment",
    searchBySubject: "Subject",
    searchByPriority: "Priority",
    pleaseSelectStartTime: "Start Time",
    pleaseSelectEndTime: "End Time"
  },
  //KPI
  KPI: {
    viewProcessingDetails: "View Processing Details",
    viewSlaDetails: "View Sla Details",
    pleaseSelectCompany: "Company",
    pleaseSelectOperation: "Operation",
    pleaseSelectDate: 'Date',
    pleaseSelectType: 'Type',
    id: "ID",
    ticketEntityId: "Ticket Entity Id",
    subject: "Subject",
    priorityName: "Priority Id",
    statusName: "Status",
    problemType: "Problem Type",
    slaStandard: "Sla Standard",
    waitTime: "Response Time(min)",
    name: "Name",
    total: "Total",
    p1event: "P1 event",
    p2event: "P2 event",
    p3event: "P3 event",
    p4event: "P4 event",
    closed: "Closed",
    pending: "Pending",
    responseTime: "Response Time",
    processing: "Processing",
    totalEvent: "Total Event",
    fundamentalStructureAlert: "Fundamental Structual Alert ",
    securityAlert: "Security Alert",
    billingAlert: "Billing Alert",
    companyContribution: "Company Contribution",
    changingRequest: "Changing Request",
    timedTaskManagement: "Timed Task Management",
    serviceRequest: "Service Request",
    eventCategory: "Event Category",
    whetherManual: "Whether Manual",
    isManual: "Is Manual",
    automaticallyELaunch: "Automatically Launch",
    manuallyLaunch: "Manually Launch",
    eventChangingTrendingStatistic: "Event changing Trend Statistic Diagram",
    casesSLAStatistic: "Each Level SLA Statistic Diagram",
    casesStatistic: "Case Statistic",
    nightFactor: "Night Duty Factor",
    documentationContribution: "Documentation Contribution",
    internalContribution: "Internal Contribution",
    unsatisfiedSLACasesStatistic: "Unsatisfied SLA Cases Statistic",
    ticketCategoryName: "Category",
    caseSLAAtEachLevel: "Case SLA At Each Level",
    dayShift: "Day Shift",
    nightShift: "Night Shift"
  },
  RedshiftMonitor: {
    //数据仓库
    redshift: "Redshift",
    addRedshift: "Add Redshift Alarm",
    cluster: "Cluster",
    accountName: "Account Name",
    accountType: "Account Type",
    status: "Status",
    region: "Region",
    operation: "Operation",
    redshiftList: "Database List",
    redshiftInfo: "Redshift Info",
    redshiftDescription: "Redshift Description",
    redshiftConfig: "Redshift Config",
    name: "Name",
    // 折线图
    line:{
      PercentageOfUsedDiskSpacePercentage:'Percentage Of Used DiskSpace(%)',
      PercentageOfUsedDiskSpace:'Percentage Of Used DiskSpace',
      HealthStatus:'Health Status',
      MaintenanceMode:'Main tenanceMode',
      ClusterCPUUsagePercentage:'Cluster CPU Usage(%)',
      ClusterCPUUsage:'Cluster CPU Usage',
      NumberOfClusterConnectionstimessecond:'Number Of Cluster Connections(Times/s)',
      NumberOfClusterConnections:'Number Of Cluster Connections',
      ClusterReadAndWriteIOPStimessecond:'Cluster Read And Write IOPS(Times/s)',
      ClusterReadIOPS:'Cluster Read IOPS',
      ClusterWriteIOPS:'Cluster Write IOPS'
    }
  },
  DocDBMonitor: {
    //数据仓库
    redshift: "DocDB",
    addRedshift: "Add DocDB Alarm",
    editRedshift:'edit DocDB Alarm',
    cluster: "Cluster",
    accountName: "Account Name",
    accountType: "Account Type",
    status: "Status",
    region: "Region",
    operation: "Operation",
    redshiftList: "DocDB List",
    redshiftInfo: "DocDB Info",
    redshiftDescription: "DocDB Description",
    redshiftConfig: "DocDB Config",
    name: "Name",
    ClusterIdentifier:'Cluster Identifier',
    instanceIdentifier:'instance Identifier',
    Identifier:'Identifier',
    role:'Role',
    EngineVersion:'Engine Version',
    AreasAndZones:'Areas And Zones',
    size:'Size',
    accountTypes:'Account Types',
    dbClusterMembers:'DbCluster Members',
    roleName:'Role Name',
    clusterCreateTime:'Cluster CreateTime',
    engineVersion:'Engine Version',
    // 折线图
    line:{
      PercentageOfUsedDiskSpacePercentage:'Percentage Of Used DiskSpace(%)',
      PercentageOfUsedDiskSpace:'Percentage Of Used DiskSpace',
      HealthStatus:'Health Status',
      MaintenanceMode:'Main tenanceMode',
      ClusterCPUUsagePercentage:'Cluster CPU Usage(%)',
      ClusterCPUUsage:'Cluster CPU Usage',
      NumberOfClusterConnectionstimessecond:'Number Of Cluster Connections(Times/s)',
      NumberOfClusterConnections:'Number Of Cluster Connections',
      ClusterReadAndWriteIOPStimessecond:'Cluster Read And Write IOPS(Times/s)',
      ClusterReadIOPS:'Cluster Read IOPS',
      ClusterWriteIOPS:'Cluster Write IOPS'
    }
  },
  ElasticSearch: {
    //ElasticSearch
    esDomain: "ES Domain",
    accountName: "Account Name",
    accountType: "Account Type",
    region: "Region",
    operation: "Operation",
    esList: "Elastic Search List",
    addEs: "Add Elastic Search Alarm",
    EsDescription: "Elastic Search Description",
    EsConfig: "Elastic Search Config",
    EsInfo: "Elastic Search Info",
    name: "Name",
    // 折线图
    line:{
      ClusterAverageCPUUtilizationPercentage:'Cluster Average CPU Utilization(%)',
      ClusterAverageCPUUtilization:'Cluster Average CPU Utilization',
      ClusterStatus:'Cluster Status',
      ClusterStatusRed:'Cluster Status(Red)',
      ClusterStatusYellow:'Cluster Status(Yellow)',
      ESClusterStatusRed:'ES Cluster Status Red',
      ESClusterStatusYellow:'ES Cluster Status Yellow',
      ESFreeStorageSpace:'ES Free Storage Space',
      ESClusterIndexWritesBlocked:'ES Cluster Index Writes Blocked',
      ESNodes:'ES Nodes',
      ESAutomatedSnapshotFailure:'ES Automated Snapshot Failure',
      ESCPUUtilization:'ES CPU Utilization',
      ESJVMMemoryPressure:'ES JVM Memory Pressure',
      ESMasterCPUUtilization:'ES Master CPU Utilization',
      ESMasterJVMMemoryPressure:'ES Master JVM Memory Pressure',
      ESKMSKeyError:'ES KMS Key Error',
      ESKMSKeyInaccessible:'ES KMS Key Inaccessible',
    }
  },
  StroageGateway: {
    //StorageGateway
    accountName: "Account Name",
    accountType: "Account Type",
    region: "Region",
    operation: "Operation",
    name: "Name",
    // 折线图
    line:{
      cachePercentUsed:'Cache Percent Used',
      cacheHitPercent:'Cache Hit Percent',
      ioWaitPercent:'IO Wait Percent',
      availabilityNotifications:'Availability Notifications',
      healthNotifications:'Health Notifications',
      cachePercentDirty:'Cache PercentDirty'
    }
  },
  application: {
    //应用
    alertRule: "Alert Rule",
    ruleName: "Rule Name",
    status: "Status",
    monitorIndex: "Monitor Index",
    indexDescription: "Index Description",
    contact: "Contact",
    category: "Category",
    instanceList: "Instance List",
    name: "Name",
    accountName: "Account Name",
    accountType: "Account Type",
    instanceID: "Instance ID"
  },
  ActionTrailSecurity: {
    //安全ActionTrail
    title: "Security(ActionTrail)",
    chinaRegion: "Is China Region",
    account: "Account",
    time: "Time",
    region: "Region",
    eventName: "Event Name",
    eventType: "Event Type",
    userName: "User Name",
    resourceType: "Resource Type",
    resourceName: "Resource Name",
    errorCode: "Error Code",
    accountName: "Account Name",
    eventTime: "Event Time",
    search: "Search",
    area:'Area',
    AccessKey:"Access Key",
    EventSource:"Event Source",
    district:"District",
    ErrorCode:"Error Code",
    RequestID:"Request ID",
    EventID:"Event ID",
    SourceIPAddress:"Source IP Address",
    EventName:"Event Name",
    RelatedResources:"Related Resources",
    pleaseSelectEventName: "Please Select Event Name"
  },
  CloudTrailSecurity: {
    //安全CloudTrail
    title: "Security(CloudTrail)",
    alertRule: "Alert Rule",
    ruleName: "Rule Name",
    status: "Status",
    monitorIndex: "Monitor Index",
    contact: "Contact",
    category: "Category",
    operation: "Operation",
    cloudTrailLogList: "CloudTrail Log List",
    account: "Account",
    region: "Region",
    time: "List",
    caseName: "Case Name",
    caseTime: "Case Name",
    resourceType: "Resource Type",
    resourceName: "Resource Name",
    addCloudTrailSecurityAlertRule: "Add CloudTrail Security Alarm",
    operationLog: "Log",
    search: "Search",
    userName: "UserName",
    accessKeyId:"AccessKey Id",
    awsRegion:"Aws Region",
    readOnly:"ReadOnly",
    errorCode:"Error Code",
    requestId:"Request Id",
    eventId:"Event Id",
    invokedBy:"Invoked By",
    eventSource:"EventSource"
  },
  TrustAdvisor: {
    consultant: 'Consultant',
    alertRule: "Alert Rule",
    ruleName: "Rule Name",
    status: "Status",
    monitorIndex: "Monitor Index",
    contact: "Contact",
    category: "Category",
    operation: "Operation",
    highAvailability: "High Availability",
    suggestion: "Suggestion",
    greatestInfluence: "Greatest Influence",
    mediumInfluence: "Medium Influence",
    lowestInfluence: "Lowest Influence",
    influencedResources: "Influenced Resources",
    security: "Security",
    performance: "Performance",
    cost: "Cost",
    alertDelay: "Alert Delay",
    overview: "Overview",
    addTrustAdvisorAlert: "Add Advisor AlertRule",
    updateTrustAdvisorAlert: "Update Advisor AlertRule",
    detail: "Detail",
    generalSuggestion: "General Suggestion",
    influence: "Influence",
    explanation: "Explanation",
    updateTime: "Update Time",
    sortedSuggestion: "Suggestions Sorted By Influence"

  },

  ARD: {
    //AffectResourceDetail
    region: "Region",
    IPAddress: "IP Address",
    regionAZ: "Regional AZ",
    volumeID: "Volume ID",
    volumeName: "Volume Name",
    volumeAttachment: "Volume Attachment",
    instanceID: "Instance ID",
    instanceType: "Instance Type",
    instaneName: "Instance Name",
    ebsOptimize: "EBS Optimize",
    status: "Status",
    snapshotID: "Snapshot ID",
    snapshotName: "Snapshot Name",
    snapshotAge: "Snapshot Age",
    reason: "Reason",
    AZ: "AZ",
    dbInstance: "Database Instance",
    backupRetentionPeriod: "Backup Retention Period",
    bucketName: "Bucket Name",
    tgtName: "Target Name",
    tgtExist: "Target Existence",
    sameOwner: "Same Owner",
    writeEnable: "Write Enabled",
    regionName: "Region Name",
    regionAPIParameter: "Regional API Parameter",
    ACLAllowList: "ACL Allow List",
    ACLAllowUploadDelete: "ACL Allow Upload/Delete",
    policyAllowAccess: "Policy Allow Access",
    ignoredBucketName: "Ignored Bucket Name",
    ASGroupName: "AutoScaling Group Name",
    loadBalancerAssociated: "Attached LoadBalancer",
    healthCheck: "Health Check",
    launchConfigName: "Launch Configuration Name",
    launchName: "Launch Name",
    launchType: "Launch Type",
    resourceName: "Resource Name",
    resourceType: "Resource Type",
    securityGroupName: "Security Group Name",
    securityGroupID: "Security Group ID",
    groupID: "Group ID",
    description: "Description",
    instanceAmount: "Instance Amount",
    totalInboudRules: "Total Inbound Rules",
    totalOutboudRules: "Total Outbound Rules",
    loadBalancerName: "LoadBalancer Name",
    loadBalancerPort: "LoadBalancer Port",
    passwordPolicy: "Password Policy",
    upperCase: "Upper Case",
    lowerCase: "Lower Case",
    number: "Number",
    nonAlphanumeric: "non-Alphanumeric",
    protocol: "Protocol",
    port: "Port",
    ipRange: "IP Range",
    zoneAmount: "Zone Amount",
    ZoneAInstance: "Zone A Instance",
    ZoneBInstance: "Zone B Instance",
    ZoneCInstance: "Zone C Instance",
    ZoneDInstance: "Zone D Instance",
    ZoneEInstance: "Zone E Instance",
    ZoneFInstance: "Zone F Instance",
    day1: "Day 1",
    day2: "Day 2",
    day3: "Day 3",
    day4: "Day 4",
    day5: "Day 5",
    day6: "Day 6",
    day7: "Day 7",
    day8: "Day 8",
    day9: "Day 9",
    day10: "Day 10",
    day11: "Day 11",
    day12: "Day 12",
    day13: "Day 13",
    day14: "Day 14",
    day14avgCPUUtlz: "14 Day Average CPU Utilization",
    amtDaysCPUUtlzOver90: "Amount of Days CPU Utilization Over 90%",
    amountOfDaysOver: "Amount of Days Over Standard",
    maxDailyMedian: "Max Daily Median",
    estimateMonthlySaving: "Estimate Monthly Saving",


  },
  // 账单
  Bill: {
    //RI页面
    RI: {
      title: "RI Page",
      currentRIList: "Current RI List",
      reservedInstanceReccmd: "Reserved Instance Recommendation",
      otherReservedList: "Current Reserved RDS,Reserved ElastiCache,Reserved Redshift,Reserved ElastiSearch,etc List",
      DHHostReservedInstance: "DH Host RI",
      proEnvInstanceStatus: "Prodduction Environment Instance Status (from 01:00pm before yesterday to yesterday 01:00pm)",
      devEnvInstanceStatus: "Development Environment Instance Status (from 01:00pm before yesterday to yesterday 01:00pm)",
      system: "System",
      quantity: "Quantity/Unit",
      startTime: "Start Time",
      endTime: "End Time ",
      rent: "Rent",
      RIRecAmount: "RI Recommendation Amount",
      account: "Account",
      subScriptionId: "Subscription ID",
      due: "Due(day)",
      series: "Series",
      instanceAmount: "Instance Amount/Unit",
      RIAmount: "RI Amount",
      detail: "Detail",
      beijing: "Beijing",
      Singapore: "Singapore"
    },
    // 账单页面
    Billing: {
      title: "Billing",
      recent10DaysAnalysis: "Recent 10 Days Services Daily Cost Analysis",
      monthlyCost: "MonthlyCost",
      dailyCostCurve: "Daily Cost Increase Curve",
      eachDimentionCost: "Each Dimension Cost Ratio",
      unit: "(unit:",
      S3: "OBS (unit: GB)",
      serviceName: "Service Name",
      linkedaccountid: "Linked Accountid",
      selectAll: 'Select All',
      billingday: "Billing Day",
      region: "Region",
      servicename: "Service Name",
      unblendedcosUnit: "Unblendedcos Unit",
      export: "Export",
      beforeDiscount: "Before Discount",
      afterDiscount: "After Discount",
      month: "Month",
      theProportionOfEachDimension: "The Proportion Of Each Dimension",
      dimenkey: "Dimenkey",
      keyvalue: "Key Value",
      detail: "Detail",
      resourceId: "ResourceId",
      usageDate: "Usage Date",
      usageQuantity: "Usage Quantity",
      totalCost: "Total Cost"
    },
    // AWS账单页面
    SLBilling: {
      resourceCategories:'Top 15 ResourceCategories',
      title: "AWS Billing Page",
      monthPrediction: " Prediction",
      monthBilling: " Billing",
      monthlyBillingAmount: "Monthly Bill Amount",
      billingOverview: "Bill Overview",
      billAmount: "Bill Amount",
      Histogram:"Histogram",
      total:"Total"
    },
    CostAllocation: {
      title: "Cost Allocation",
      tableName: "Table Name",
      applicationName: "Application Name",
      costCenter: "Cost Center",
      name: "Name",
      proportionOfContribution: "Proportion Of Contribution(%)",
      timer: "Start Time - End Time",
      batchExport: "Batch Export"
    },
    ResourceOptimization: {
      title: "Resource Optimization",
      pleaseSelectProjectValue: "Please Select Project Value",
      RIDataSource: "RI Data Source",
      prompt: "Prompt",
      singleAvailabilityStandardizedUnit: "Single Availability Standardized Unit",
      multiAvailabilityStandardizedUnit: "Multi Availability Standardized Unit",
      pleaseSelectLabelValue: "Please Select Label Value",
      pleaseSelectAccount: "Please Select Account",
      customer: "Customer",
      engineType: "Engine Type",
      elasticsearchCount: "Elastic Search Count(Real-time Quantity)",
      RIRecommendedQuantity: "RI Recommended Quantity",
      RIAvailableQuantity: "RI Available Quantity",
      purchaseRate: "Purchase Rate",
      exactlyMatchTheSavings: "Exactly Match The Savings",
      currentlyReservedToSaveCosts: "Currently Reserved To Save Costs",
      toolTips: "All Upfront Charges Are Charged For All Reserved Instances",
      os: 'OS',
      EC2Count: "EC2 Count(Real-time Quantity)",
      clientCompany: "Client Company",
      specialDiscountOrNot: "Special Discount Or Not",
      CUDRecommendationPage: "CUD Recommendation Page",
      recommendedPurchaseCUDNumber: "Recommended Purchase CUD Number",
      purchasedCUDNumber: "Purchased CUD Number",
      noMatchCUD: "The Average Number Of CUDs Did Not Match This Month",
      nextMonthCUD: "Recommend Buying CUD Next Month To Save The Cost",
      CUDUsage: "CUD Usage",
      utilizationRate: "Utilization Rate",
      queryInterval: "Please Enter The Query Interval",
      coverageRate: "Coverage Rate",
      payAccount: "Pay Account"
    },
    CostCalculation: {
      title: "Cost Calculation",
      reset: "Reset",
      EC2: "EC2 (server instance)",
      storage: "Storage",
      RDS: "RDS (Relational Database Service)",
      subtotal: "Subtotal",
      AWSTotal: "AWS Total",
      purpose: "Purpose",
      region: "Region",
      cache: "Cache",
      OS: "OS",
      paymentMethod: "Payment Type",
      amount: "Amount",
      unitPrice: "Unit Price",
      month: "Month",
      price: "Price",
      operation: "Operation",
      storageType: "Storage Type",
      serviceType: "Service Type",
      storageCapacity: "Storage Capacity",
      preConfigIOPS: "PreConfiged IOPS Amount",
      databaseType: "Database Type",
      deploymentMethod: "Deployment Method",
      year: "Year",
    },
    ebilling:{
      dashboard:"Dashboard",
      account:"Account",
      tag:"Tag",
      service:"Service",
      LicenseRI:"License RI",
      NolicenceRI:"Nolicence RI",
      region:"Region",
      custom:"Custom",
      bill:"Bill",
      awsBill:"AWS Bill"
    }

  },


  companyManagement: {
    //公司管理
    title: "Company Management",
    companyName: "Company Name",
    companyAddress: "Company Address",
    parentCompanyName: "Parent Company Name",
    emailNotificationReply: "Email Notification Reply",
    AWSHealthMonitorDashboard: "AWS Health Monitor Dashboard",
    billingAddress: "Billing Address",
    customerType: "Customer Type",
    operation: "Operation",
    addCompany: "Add Company",
    yes: "Yes",
    no: "No",
  },
  RIAccountGroupManagement: {
    //财务账户组管理
    RIAccountGroupName: "Billing Account Group Name",
    addRIAccountGroup: "Add Billing Account Group",
    editRIAccountGroup: "Edit Billing Account Group",
    configuration: "Config",
    region: "Region",
    area: "Area",
    AvailabilityZone: "Availability Zone",
    comment: "Comment",
    operation: "Operation",
    RIAccountGroupConfig: "Billing Account Group Config",
    China: "China",
    Overseas: "Overseas",
    companyName: "Company Name",
    Native: "Native",
    addAccount: "Add Account",
    accountName: "Account Name",
    accountID: "Account ID",
    AZ: "Region",
    cancel: "Cancel",
    title: "Billing Account Group",
    queryByAccountGroupName: 'Account Group Name',
    accountGroupNameNotEmpty: 'account group name not empty',
    accountGroupNameValidateMsg: 'Account group name is 4-20 characters',
    pleaseSelectArea: 'please select area',
    pleaseSelectRegion: 'please select region'

  },
  MenuManagement: {
    //菜单管理
    menuManagement: "Menu Management",
    addMenu: "Add Menu",
    menuName: "Menu Name",
    category: "Category",
    sort: "Sort",
    menuIcon: "Menu Icon",
    permissionIcon: "Permission Identification",
    addressPath: "Address Path",
    componentPath: "Component Path",
    operation: "Operation",
    edit: "Edit",
    delete: "Delete",
    editMenu: 'Edit Menu',
    upperMenu: 'Upper Menu',
    buttonName: 'Button Name',
    menuTitle: 'Menu Title',
    englishTitle: 'English Title',
    directory: 'Directory',
    menu: 'Menu',
    button: 'Button',
    pleaseSelectType: 'Please Select Type',
    pleaseInputMenuTitle: 'Please Select Menu Title',
    pleaseInputEnglishTitle: 'Please Select English Title',
    pleaseInputSort: 'Please Select Sort',
    pleaseInputAddressPath: 'Please Select Address Path',
    pleaseInputComponentPath: 'Please Select Component Path',
    pleaseInputMenuIcon: 'Please Select Menu Icon',
    pleaseInputButtonName: 'Please Select Button Name',
    pleaseInputPermissionIcon:'Please Select Permission Icon'

  },
  AWSBilling: {
    //AWS账单页面
    prediction: "Prediction",
    billings: "Billing",
    monthlyBillingCost: "Monthly Billing Cost",
    billingPreview: "Billing Preview",
    top15ResourceType: "Top15 Resource Type"
  },
  cudrecommendation:{
    //CUD推荐页面
    commitmentId:"CUD ID",
    name:"Name",
    start:"Start",
    end:"End",
    autoRenew:"Auto Renew",
    typeName:"Type Name",
    statusName:"Status Name",
    planName:"Plan Name",
    search:"Search",
   },
   cudRecommendForm:{
    resourceType:"Please Select Company",
    accountId:"Please Select Account Number",
    cudType:"Please Select Model",
    availableArea:"Please Select The Available Area",
    resourceType:"Please Select Resource Type",
  },
  //预留实例
  reservedInstance:{
    //覆盖率报告
    coverage:{
      pleaseSelect:"Please Select",
      customer: "Customer",
      accountName:"Account Name",
      accountId:"Account Id",
      EC2:"EC2",
      RDS:"RDS",
      Redshift:"Redshift",
      ElastiCache:"Elasti Cache",
      Opensearch:"Opensearch"
    },
  },
  PatchEasy: {
    PatchPolicy: {
      //补丁策略
      title: "Patch Policy",
      addStrategy: "Add Policy",
      name: "Name",
      policyName: "Policy Name",
      account: "Account",
      dispatchDuty: "Dispatch Duty",
      config: "Config",
      patchstdConfig: "Patch Standard Config",
      patchcmdPara: "Patch Command Parameter",
      deleteStrategy: "Delete Strategy",
      instantRun: "Instant Run",
      addStdConfig: "Add Standard Config",
      stdID: "Standard ID",
      stdName: "Standard Name",
      description: "Description",
      OS: "OS",
      defaultStd: "Default Standard",
      productSeries: "Product Series",
      product: "Product",
      category: "Category",
      severityLevel: "Severity Level",
    },

    PatchCmd: {
      //命令列表
      title: "Patch Command",
      cmdID: "Command ID",
      requestDate: "Request Date",
      fileName: "File Name",
      comment: "Comment",
      tgt: "# Target",
      error: "# Error",
      submitDelay: "# Submit Delay",
      complete: "# Complete",
      search: "Search",
      command: "Command",
      commandHistory: "Command History",
      account: "Account",
      region: "Region",
      selectByAccount: "Account",
      selectByRegion: "Region",
      selectByCmdID: "CmdID",
      commandDetails: "Command Details",
      commandStatus: "Command Status",
      overallStatus: "Overall Status",
      detailedStatus: "Detailed Status",
      goalsAndOutputs: "Goals And Outputs",
      selectByInstanceID: "InstanceID",
      instanceID: "Instance ID",
      instanceName: "Instance Name",
      backupID: "Backup ID",
      startTime: "Start Time",
      completeTime: "Complete Time",
      viewOutput: "View",
      output: "Output",
      descriptionAndStatus: "Step One Description And Status",
      responseCode: "Response Code",
      stepName: "Step Name",
      stepOneOutput: "Step One Output",
      tip: "The command output displays up to 2500 characters. If you specified an S3 bucket or CloudWatch log group when running the command, you can view the complete command output in the Amazon S3 or CloudWatch logs.",
      nameAndDescription: "Name And Description",
      commandDocument: "Command Document",
      documentVersion: "Document Version",
      requestTime: "Request Time",
      commandParameters: "Command Parameters",
      parameter: "Parameter",
      deliveryTimeout: "Delivery Timeout(seconds)",
      executionTimeout: "Execution Timeout(seconds)"
    }
  },

  RAM: {
    //资源配置管理
    AWS: {
      computeInstance: {
        //计算实例
        title: "EC2",
        accountID: "Account ID",
        accountName: "Account Name",
        region: "Region",
        instanceName: "Instance Name",
        instanceID: "Instance ID",
        instanceType: "Instance Type",
        cache: "Cache",
        diskStorage: "Disk Storage",
        T2T3Unlimited:"T2/T3 Unlimited",
        OperatingSystem:"Operating System",
        InstanceStatus:"Instance Status",
        Project:"Project",
        Owner:"Owner",
        SystemHealthStatus:"System Health Status",
        InstanceHealthStatus:"Instance Health Status",
        PublicIP:"PublicIP",
        PrivateIP:"PrivateIP",
        SubnetID:"SubnetID",
        CreationTime:"Creation Time",
        SecurityGroupID:"SecurityGroup ID",
        SecurityGroupName:"SecurityGroup Name",
        CPU:"CPU",
        AMIID:"AMI ID",
        VPCID:"VPC ID",
        EBSDevices:"EBS Devices",
        stateName:"State Name",
      },
      eks:{
        title:"EKS",
        name:"Name",
        version:"Version",
        status:"Status",
        platformVersion:"Platform Version",
        createdAt:"Created At",
        endpoint:"Endpoint",
        pointName:"Point Name",
        releaseVersion:"AMI Release Version",
        minSize:"Min Size",
        maxSize:"Max Size",
        amiType:"Ami Type",
        diskSize:"Disk Size"
      },
      emr:{
        title:"EMR",
        clusterId:"Cluster Id",
        name:"Name",
        status:"Status",
        logUrl:"Log Url",
        releaseLabel:"Release Label",
        normalizedInstanceHours:"Normalized Instance Hours",
        masterPublicDnsName:"Master Public DnsName",
        clusterArn:"Cluster Arn",
        creationDate:"Creation Date",
      },
      DedicatedHosting:{
        //专用主机
        title: "Dedicated Hosting",
        accountID: "Account ID",
        accountName: "Account Name",
        region: "Region",
        name:"Name",
        hostId:"HostId",
        availabilityZone:"Availability Zone",
        state:"State",
        instanceFamily:"Instance Family",
        instanceType:"Instance Type",
        },
      database: {
        //数据库
        title: "Database",
        accountName: "Account Name",
        accountID: "Account ID",
        instanceName: "Instance Name",
        terminalNode: "Terminal Node",
        engine: "Engine",
        instanceType: "Instance Type",
        storageSize: "Storage Size",
        multipleAZ: "Multiple AZ",
        maintenance: "Maintenance",
        subnetGroup: "Subnet Group",
        runningStatus: "Running Status",
        launchTime: "Launch Time",
        backupPolicy: "Backup Policy",
        subnetID: "SubnetID",
        region: "Region",
        iops: "IOPS",

      },
      VirtualNetwork: {
        //虚拟网络
        title: "Virtual Network",
        accountName: "Account Name",
        accountID: "Account ID",
        VPCName: "VPC Name",
        DHCPSettingSet: "DHCP Setting Set",
        defaultVPC: "Default VPC",
        runningStatus: "Running Status"
      },
      Elasticsearch: {
        //Elasticsearch
        region: "Region",
        title: "Elastic Search",
        accountName: "Account Name",
        accountID: "Account ID",
        domainName: "Domain Name",
        elasticsearchVersion: "Elastic Search Version",
        volumeType: "Volume Type",
        volumeSize: "Volume Size",
        instanceType: "Instance Type(Date)",
        instanceCount: "Number Nodes",
        dedicatedMasterType: "Instance Type(Master)",
        dedicatedMasterCount: "Number Master Instance"
      },
      ElasticBlockStorage: {
         //弹性快储存
        title: "EBS",
        accountName: "Account Name",
        accountID: "Account ID",
        volumeName: "Volume Name",
        volumeID: "Volume ID",
        volumeCapacity: "Volume Capacity",
        volumeCategory: "Volume Category",
        attachedStatus: "Attached Status",
        attachedInstanceID: "Attached Instance ID",
      },
      ElasticLoadBalancer: {
        //弹性负载均衡
        title: "ELB",
        accountName: "Account Name",
        accountID: "Account ID",
        ELBName: "ELB Name",
        DNSName: "DNS Name",
        loadbalancerType:"Load Balancer Type",
        instanceID: "Instance ID",
        region: "Region",
        stateName: "State Name"
      },
      StorageBin: {
        //储存桶
        title: "S3",
        accountName: "Account Name",
        accountID: "Account ID",
        binName: "Bin Name",
        bucketStorage: "Bucket Storage",
        launchTime: "Launch Time",
        establishPerson: "Establish Person",
        bucketLogging: "Bucket Logging",
        bucketLoggingUrl: "Bucket Logging URL",
        binAuthorization: "Bin Authorization",
        encryption: "Encryption",
        public: "Public",
        lifeCycle: "Life Cycle"
      },
      Redshift: {
        accountName: "Account Name",
        accountID: "Account ID",
        clusterName: "Cluster Name",
        clusterStatus: "Cluster Status",
        databaseStatus: "Database Status",
        releaseStatus: "Release Status",
        maintain: "Maintenance",
        nodeType: "Node Type",
        region: "Region",
        clusterSubnetGroup: "Cluster Subnet Group",
        recentEventsAmount: "Recent Event Amount",
        nodesAmount: "Node Amount",
        clusterParametersGroup: "Cluster Parameter Group",
        subnet: "Subnet"
      },
      ElasticCache: {
        //弹性缓存
        memcachedTitle: "Memcached",
        redisTitle: "Redis",
        accountName: "Account Name",
        accountID: "Account ID",
        region: "Region",
        clusterName: "Cluster Name",
        statusName: "Status",
        createdTime: "Created Time",
        primaryEndpoint: "Primary Endpoint",
        configurationEndpoint: "Configuration Endpoint",
        engine: "Engine",
        nodeType: "Node Type",
        slice: "Slice",
        nodesNumber: "Nodes Amount",
        multiAz: "MultiAz",
        securityGroups: "Security Groups",
        NodeID:"Node ID",
        TerminalNode:"Terminal Node",
        Port:"Port",
        AvailabilityZone:"Availability Zone",
        CurrentRole:"Current Role"
      },
      RI: {
        //预留实例
        EC2: {
          accountName: "Account Name",
          accountID: "Account ID",
          region: "Region",
          instanceType: "Instance Type",
          start: "Start",
          overdue: "Overdue",
          due: "Due",
          paymentMethod: "Payment Method",
          providedType: "Provided Type",
          platform: "Platform",
          status: "Status",
          rentTime: "Rent Time",
          instanceAmount: "Instance Amount",
          standardizeFactor: "Standardize Factor"
        },
        RDS: {
          accountName: "Account Name",
          accountID: "Account ID",
          region: "Region",
          reservedInstanceID: "Reserved Instance ID",
          engine: "Engine",
          instanceType: "Instance Type",
          paymentMethod: "Payment Method",
          status: "Status",
          start: "Start",
          overdue: "Overdue",
          due: "Due",
          multipleAvailabilityZone: "Enable Multiple Availability Zone",
          amount: "Amount",
          standardizeFactor: "Standardize Factor"
        },
        ElasticCache: {
          accountName: "Account Name",
          accountID: "Account ID",
          region: "Region",
          reservedCacheNodeID: "Reserved Cache Node ID",
          productDescription: "Product Description",
          CacheNodeType: "Cache Node Type",
          productType: "Product Type",
          status: "Status",
          start: "Start",
          overdue: "Overdue",
          nodeAmount: "Node Amount",
          due: "Due"
        },
        RedShift: {
          accountName: "Account Name",
          accountID: "Account ID",
          region: "Region",
          reservedNodeID: "Reserved Node ID",
          NodeType: "Node Type",
          productType: "Product Type",
          status: "Status",
          start: "Start",
          overdue: "Overdue",
          due: "Due",
          amount: "Amount"
        },
        ElasticSearch: {
          name: "Name",
          id: "id",
          accountName: "Account Name",
          accountID: "Account ID",
          region: "Region",
          reservedCacheNodeID: "Reserved Cache Node ID",
          productDescription: "Product Description",
          CacheNodeType: "Cache Node Type",
          productType: "Product Type",
          status: "Status",
          start: "Start",
          overdue: "Overdue",
          nodeNumber: "Node Amount",
          due: "Due"
        }
      },
      ElasticIP: {
        //弹性IP
        title: "EIP",
        accountName: "Account Name",
        accountID: "Account ID",
        ElasticIP: "Elastic IP",
        allocatedID: "Allocated ID",
        privateIP: "Private IP",
        AttachedInstance: "Attached Instance"
      },
      routingTable: {
        //路由表
        title: "Route Resource",
        accountName: "Account Name",
        accountID: "Account ID",
        routingTableName: "Routing Table Name",
        routingTableID: "Route ResourceID",
        isMainRoutingTable: "Is Main Routing Table",
        ipAddress:"Ip Address",
        instanceId:"Instance Id",
        gatewayId:"Gateway Id",
        routeState:"Route State"

      },
      Gateway: {
        //网关
        title: "Gateway",
        accountName: "Account Name",
        accountID: "Account ID",
        gatewayName: "Gateway Name",
        gatewayID: "Gateway ID"
      },
      Subnet: {
        //子网
        title: "Subnet",
        accountName: "Account Name",
        accountID: "Account ID",
        subnetName: "Subnet Name",
        subnetID: "Subnet ID",
        availabilityZone: "Availability Zone",
        availableIP: "Available IP Amount"
      },
      SecurityGroup: {
        //安全组
        title: "Security Group",
        accountName: "Account Name",
        accountID: "Account ID",
        securityGroupName: "Security Group Name",
        securityGroupID: "Security Group ID",
        protocolType: "Protocol Type",
        protocol: "Protocol",
        port: "Port",
        resource: "Resource",
        accessRules: "Access Rules"
      },
      Event: {
        // 事件
        title: "Event Change Record",
        accountName: "Account Name",
        accountID: "Account ID",
        region: "Region",
        resource: "Resource",
        resourceId: "Resource ID",
        instanceType: "Instance Type",
        eventType: "Event Type",
        beforeChangeStatus: "Previous Status",
        afterChangeStatus: "Current Status",
        eventTime: "Event Time"
      },
      IdentityAndAccessManagement: {
        //身份和访问管理
        title: "IAM",
        accountName: "Account Name",
        accountID: "Account ID",
        userName: "User Name",
        group: "Groups",
        accessKeyAge: "Access Key age",
        passwordAge: "Password age",
        lastActivity: "Last activity",
        mfa: "MFA",
        policyName: "Policy Name",
        policyTypeName: "Policy Type Name",
        policyFrom: "PolicyFrom"
      },
      IAM:{
        Group:{
          // 组
          title:"Group",
          AccountName:"Account Name",
          AccountId:"Account Id",
          GroupName:"Group Name",
          NumberOfPeople:"Number Of People",
          PolicyType:"Policy Type",
          PolicyName:"Policy Name",
          pleaseEnterGroupName: "Please Enter Group Name",
          pleaseEnterPolicyName: "Please Enter Policy Name"
        },
        Policy:{
          // 策略
          title:"Policy",
          AccountName:"Account Name",
          AccountId:"Account Id",
          PolicyName:"Policy Name",
          PolicyType:"Policy Type"
        },
        AKSK: {
          pleaseEnterIamUserName: "Please Enter IAM User Name"
        }
      },
      Backup:{
        Repository:{
          title:"Repository",
          backupVaultName:"Backup Vault Name",
          numberOfRecoveryPoints:"Number Of Recovery Points",
          encryptionKeyArn:"Encryption Key Arn",
          creationDate:"Creation Date",
          recoveryPointArn:"Recovery Point Arn",
          status:"Status",
          resourceArn:"Resource Arn",
          resourceType:"Resource Type",
          deleteAfterDaysDesc:"Delete After Days Desc",
          moveToColdStorageAfterDaysDesc:"Move To Cold Storage After Days Desc",
        },
        Plan:{
          title:"Plan",
          backupPlanId:"Backup Plan Id",
          backupPlanName:"Backup Plan Name",
          lastExecutionDate:"Last Execution Date",
          creationDate:"Creation Date",
          ruleName:"Rule Name",
          targetBackupVaultName:"Target Backup Vault Name",
          destinationBackupVaultArn:"Destination Backup Vault Arn",
          selectionName:"Selection Name",
          iamRoleArn:"Iam Role Arn",
          creationDate:"Creation Date",
          backupPlanRule:"Backup Plan Rule",
          resourceAllocation:"Resource Allocation"
        }
    },
      DynamoDB: {
        partitionKey: 'Partition Key',
        sortKey: 'Sort Key',
        index: 'Index',
        deleteProtection: 'Delete Protection',
        readCapacity: 'Read Capacity',
        readCapacityMode: 'Read Capacity Mode',
        writeCapacity: 'Write Capacity',
        writeCapacityMode: 'Write Capacity Mode',
        totalSize: 'Total Size',
        listClass: 'List Class',
        projectionAttribute: 'Projection Attribute',
        numberOfEntries: 'Number Of Entries'
      },
      ECR: {
        title: 'Elastic Container Registry',
        repositoryName: 'Repository Name',
        enterRepositoryName: 'Please enter replicationInstances name',
        labelInvariance: 'Label Invariance',
        pushScan: 'Push scan',
        encryptionType: 'Encryption Type',
        imageTag: 'Image Tag',
        componentType: 'Component Type',
        pushPosition: 'Push Position',
        size: 'Size',
        imageURI: 'Image URI',
        digest: 'Digest',
        scanningState: 'Scanning State',
        bug: 'Bug'
      },
      ECS: {
        title: 'Elastic Container Service',
        clusterName: 'Cluster Name',
        enterClusterName: 'Please enter cluster name',
        service: 'Service',
        running: 'Running',
        containerInstance: 'Container Instance',
        monitoring: 'CloudWatch Monitoring',
        capacityProviderStrategy: 'Capacity Provider Strategy',
        clusterDescription: 'Cluster Description',
        serviceName: 'Service Name',
        status: 'Status',
        serviceType: 'Service Type',
        rolloutState: 'Rollout State',
        taskDefinition: 'Task Definition',
        launchType: 'Launch Type',
        lastStatus: 'Last Status',
        desiredStatus: 'Desired Status',
        runningState: 'Running State',
        startTime: 'Start Time',
        memory: 'Memory(GB)',
        updateSuccess: 'Update Success',
        pleaseWait: 'Exporting,please wait...',
        exportSuccess: 'Export Success'
      },
      KMS: {
        aliases: 'Aliases',
        enterAliases: 'Please enter aliases',
        keyId: 'Key ID',
        status: 'Status',
        creationDate: 'Creation Date',
        dueDate: 'Due Date',
        source: 'Source',
        keyType: 'Key Type',
        keySpecification: 'Key Specification',
        keyUsage: 'Key Usage'
      },
      DMS: {
        serverlessReplications: 'Serverless Replications',
        replicationInstances: 'Replication Instances',
        name: 'Name',
        type: 'Type',
        sourceEndpoint: 'Source Endpoint',
        targetEndpoint: 'Target Endpoint',
        created: 'Created Time',
        enterName: 'Please enter name',
        class: 'Class',
        engineVersion: 'Engine Version',
        availabilityZone: 'Availability Zone',
        publicIPAddress: 'Public IP Address',
        privateIPAddress: 'Private IP Address',
        multiAZ: 'Multi AZ'
      }
  },
    Azure: {
      VirtualMachine: {
        //虚拟机
        title: "VirtualMachine",
        accountName: "Account Name",
        subscriptionName: "Subscription Name",
        subscriptionID: "Subscription ID",
        resourceGroup: "Resource Group",
        instanceName: "Instance Name",
        instanceType: "Instance Type",
        cache: "Cache",
        diskStorage: "Disk Storage",
        operatingSystem: "Operating System",
        instanceStatus: "Instance Status",
        project: "Project",
        owner: "Owner",
        publicIP: "Public IP",
        privateIP: "Private IP",
        virtualNetworkAndSubnet: "Virtual Network/Subnet",
        NetworkSecurityGroup: "Network Security Group"
      },
      database: {
        //数据库
        title: "Database",
        accountName: "Account Name",
        subscriptionName: "Subscription Name",
        subscriptionID: "Subscription ID",
        resourceGroup: "Resource Group",
        databaseName: "Database Name",
        serverName: "Server Name",
        location: "Location",
        status: "Status",
        connectionString: "Connection String",
        pricingLevel: "Pricing Level"
      },
      VirtualNetwork: {
        //虚拟网络
        title: "Virtual Network",
        accountName: "Account Name",
        subscriptionName: "Subscription Name",
        subscriptionID: "Subscription ID",
        resourceGroup: "Resource Group",
        VPCName: "VPC Name",
        location: "Location",
        addressSpace: "Address Space"
      },
      trusteeDisk: {
        //托管磁盘
        title: "Volume",
        accountName: "Account Name",
        subscriptionName: "Subscription Name",
        subscriptionID: "Subscription ID",
        resourceGroup: "Resource Group",
        diskConfig: "Disk Config",
        status: "Status",
        owner: "Owner",
        operatingSystem: "Operating System",
        launchTime: "Launch Time"
      },
      storageAccount: {
        //存储账户
        title: "Storage Account",
        storageAccountName: "Storage Account Name",
        accountName: "Account Name",
        subscriptionName: "Subscription Name",
        subscriptionID: "Subscription ID",
        resourceGroup: "Resource Group",
        performance: "Performance",
        status: "Status",
        duplicationAndRedundant: "Duplication/Redundancy",
        accountType: "Account Type"
      },
      appService:{
        title:"App Service",
        AccountName:"Account Name",
        AccountID:"Account ID",
        SubscriptionName:"Subscription Name",
        SubscriptionID:"Subscription ID",
        ResourceGroup:"Resource Group",
        Name:"Name",
        Area:"Area",
        Status:"Status",
        Type:"Type",
        ServerFarm:"Server Farm"
      },
      loadBalance:{
        title:"Load Balance",
        AccountName:"Account Name",
        AccountID:"Account ID",
        SubscriptionID:"Subscription ID",
        Name:"Name",
        ResourceGroup:"Resource Group",
        Area:"Area",
        BackendPool:"Backend Pool",
        HealthDetection:"Health Detection",
        LoadBalancingRules:"Load Balancing Rules",
        DedicatedIPAddress:"Dedicated IP Address",
        SKU:"SKU"
      }
    },
    ALI:{
      computeInstance: {
        //计算实例
        title: "Calculation example",
        accountID: "Account ID",
        accountName: "Account Name",
        region: "Region",
        instanceName: "Instance Name",
        instanceID: "Instance ID",
        instanceType: "Instance Type",
        cache: "Cache",
        diskStorage: "Disk Storage",
        ImageId:"Image Id",
        amazonVpcId:"Amazon Vpc Id",
        OperatingSystem:"Operating System",
        InstanceStatus:"Instance Status",
        Project:"Project",
        Owner:"Owner",
        PublicIP:"Public IP",
        PrivateIP:"Private IP",
        InstanceCreatedTime:"Instance Created Time",
      },
      database: {
        //数据库
        title: "Database",
        accountName: "Account Name",
        accountID: "Account ID",
        engine: "Engine",
        name:"Name",
        instanceType: "Instance Type",
        storageSize: "Storage Size",
        stateName: "State Name",
        createdTime: "Created Time",
        version:"Version",
        nodeNumber:"Node Number",
        endpoint:"End Point",
        maintenance: "Maintenance",
        region: "Region",
        iops: "IOPS",
      },
      ElasticBlockStorage: {
        //弹性块存储
        title: "Elastic Block Storage",
        accountName: "Account Name",
        accountID: "Account ID",
        cloudStorageName: "CloudStorage Name",
        cloudStorageID: "CloudStorage ID",
        cloudStorageCapacity: "CloudStorage Capacity",
        cloudStorageCategory: "CloudStorage Category",
        attachedStatus: "Attached Status",
        attachedInstanceID: "Attached Instance ID"
      },
      ElasticIP: {
        //弹性公网IP
        title: "Elastic IP",
        accountName: "Account Name",
        accountID: "Account ID",
        ElasticIP: "Elastic IP",
        allocatedID: "Allocated ID",
        privateIP: "Private IP",
        AttachedInstance: "Attached Instance",
        searchByElasticIP: "Please Enter Elastic IP"
      },
      ElasticLoadBalancer: {
        //弹性负载均衡
        title: "ElasticLoad Balancer",
        accountName: "Account Name",
        accountID: "Account ID",
        ELBName: "ELB Name",
        DNSName: "DNS Name",
        availabilityZone: "Availability Zone",
        instanceID: "Instance ID",
        targetCluster: "Target Cluster",
        securityGroup: "Security Group",
        region: "Region",
        stateName: "State Name"
      },
      Redis:{
        //Redis
        title:"Redis",
        instanceId:"Instance Id",
        instanceName:"Instance Name",
        connectionDomain:"Connection Domain",
        instanceStatus:"Instance Status",
        instanceClass:"Instance Class",
        engineVersion:"Engine Version",
        architectureType:"Architecture Type"
      },
      Vpc:{
        title:"Vpc",
        name:"Name",
        id:"VPC ID",
        Cidr:"VPC CIDR",
        region:"Region",
        defaultVpc:"Default Vpc",
        stateName:"State Name",
      },
      Oss:{
        title:"Oss",
        name:"OSS Name",
        creationDateString:"Creation Date String",
        displayName:"Display Name",
        extranetEndpoint:"Extranet End point",
        intranetEndpoint:"Intranet End point",
        displayId:"Display Id",
        access:"Access",
        defaultEncryption:"Default Encryption",
    },
    NatGateway:{
      title:"NAT",
      natGatewayId:"Nat Gateway Id",
      state:"State",
      publicIp:"Public Ip",
      privateIp:"Private Ip",
      vpcId:"VPC",
      createTime:"Create Time",
      name:"Nat Gateway Name",
    },
    Ack: {
      ackTitle: "Ack(k8s)",
      accountID: "Account ID",
      accountName: "Account Name",
      region: "Region",
      accountType:"Account Type",
      clusterId:"Cluster Id",
      clusterName:"Cluster Name",
      clusterType:"Cluster Type",
      profile:"Profile",
      clusterSpec:"Cluster Spec",
      vpcId:"Vpc Id",
      size:"Size",
      state:"State",
      created:"Created",
      updated:"Updated"
    },
    AutoScaling:{
      title:"Auto Scaling",
      accountType:"Account Type",
      scalingGroupId:"Scaling Group Id",
      scalingGroupName:"Scaling Group Name",
      groupType:"Group Type",
      totalInstanceCount:"Total Instance Count",
      lifecycleState:"Lifecycle State",
      minSize:"Min Size",
      maxSize:"Max Size",
      groupModificationTime:"Group Modification Time",
      isActive:"Is Active",
    },
    Sls:{
      title:"Sls",
      accountTypeName:"Account Type Name",
      logstoreName:"Logstore Name",
      projectName:"Project Name",
    },
    ClickHouse:{
      title:"Click House",
      accountID: "Account ID",
      accountName: "Account Name",
      region: "Region",
      accountType:"Account Type",
      filterByClusterId: "Filter By Cluster Id",
      clusterId:"Cluster Id",
      nodeCount:"Node Count",
      storageType:"Storage Type",
      nodeStorage:"Node Storage ",
      nodeClass:"Node Class",
      clusterStatus:"Cluster Status",
      controlVersion:"Version",
      createTime:"Create Time"
    },
    Waf:{
      title:"Waf",
      accountID: "Account ID",
      accountName: "Account Name",
      region: "Region",
      accountType:"Account Type",
      instanceId:"Instance Id",
      statusName:"Status Name",
      versionName:"Version Name"
    },

    Cen:{
      //Cen
      title:"Cen",
      cenId:"Cen Id",
      name:"Name",
      description:"Description",
      status:"Status",
      ipv6Level:"Ipv6 Level",
      protectionLevel:"Protection Level",
      resourceGroupId:"Resource Group Id",
      creationTime:"Creation Time",
    },
    Kafka:{
      title:"Mq Kafka",
      accountIdString:"Account ID",
      accountName:"Account Name",
      region: "Region",
      instanceId:"Instance ID",
      name:"Instance Name",
      serviceStatusStr:"Service Status",
      vpcId:"VPC ID",
      specType:"Spec Type",
      deployTypeStr:"Deploy Type",
      diskTypeStr:"Disk Type",
      diskSize:"Disk Size",
      createTimeStr:"Create Time"
    },
    ReservedInstances:{
      title:"ECS Reserved Instance",
      reservedInstanceId: "Reserved Instance ID",
      name : "Name",
      platform : "Platform",
      instanceType : "Instance Type",
      status : "Status",
      creationTime : "Creation Time",
      expiredTime : "Expired Time",
      instanceAmount : "Instance Amount"
    }
  },
  GCP:{
    computeInstance: {
      //计算实例
      Project:"Project",
      Owner:"Owner",
    },
    ElasticBlockStorage: {
      //弹性快存储
      awsZone:"AWS Zone",
      region:"Region",
      encrypted:"Encrypted",
      accountName:"Account Name",
      accountIdString:"Account Id String",
      name:"Name",
      volumeAwsId:"Volume AWS Id",
      capacity:"Capacity",
      type:"Type",
      stateName:"State Name",
    },
    RelationalDataBaseResource:{
      //数据库
      name:"Name",
      endpoint:"End Point",
      type:"Type",
      project:"Project",
      backupPolice:"Backup Police",
      filterByInstanceName:"Filter By Instance Name",
    },
    ElasticLoadBalancer:{
     //负载均衡
     region:"Region",
     accountTypeName:"Account Type Name",
     stateName:"State Name"
    },
    CloudStorageGcp:{
      //CloudStorage
      title:"Cloud Storage",
      accountType:"Account Type",
      location:"Location",
      projectId:"Project Id",
      name:"Name",
      metaGeneration:"Meta Generation",
      storageClass:"Storage Class",
      timeCreated:"Time Created",
      isActive:"Is Active"
    },
    Redis:{
      projectId:"Project Id",
      instanceName:"Instance Name",
      cacheClusterId:"Cache Cluster Id",
      version: 'Version',
      cache:'Cache',
      timeCreated:'Time Created',
    },
    Kubernetes:{
      title: "GKE",
      name: "Cluster Name",
      initialClusterVersion: "Initial Cluster Version",
      currentMasterVersion: "Current Master Version",
      currentNodeVersion: "Current Node Version",
      currentNodeCount: "Current Node Count",
      network: "Network",
      subnetWork: "Subnet Work",
      status: "Cluster Status",
      nodeName:"nName",
      nodeLocations:"Location",
      nodeMachineType:"Machine Type",
      nodeDiskSize:"Disk Size",
      nodeImageType:"Image Type",
      nodeDiskType:"Disk Type",
      nodeInitialNodeCount:"Initial Node Count",
      nodeVersion:"Version",
      nodeStatus:"Status",
    },
    loggingstored:{
      title:"Logging Stored",
      accountName:"Account Name",
      accountID:"Account ID",
      location:"Location",
      projectId:"Project Id",
      name:"Name",
      description:"Description",
      retentionDays:"Retention Days",
      locked:"Locked",
      createTime:"Create Time",
    },
    loggingroute:{
      title:"Logging Route",
      accountName:"Account Name",
      accountID:"Account ID",
      location:"Location",
      projectId:"Project Id",
      name:"Name",
      description:"Description",
      type:"Type",
      destination:"Destination",
      createTime:"Create Time",
    },
    common:{
      location: "Location",
      projectId: "Project Id"
    }
  },
    HWC: {
      ECS: {
        title: "ECS",
        accountID: "Account ID",
        accountName: "Account Name",
        region: "Region",
        instanceName: "Instance Name",
        instanceID: "Instance ID",
        instanceType: "Instance Type",
        state: "State",
        diskStorage: "Disk Storage（GB）"
      },
      RDS: {
        title: "RDS",
        accountID: "Account ID",
        accountName: "Account Name",
        region: "Region",
        instanceName: "Instance Name",
        instanceID: "Instance ID",
        engineVersion: "Engine Version",
        state: "State",
        instanceType: "Instance Type"
      },
      EVS: {
        title: "EVS",
        diskName: "Disk Name",
        diskID: "Disk ID",
        diskType: "Disk Type",
        diskStorage: "Disk Storage",
        encryption: "Encryption"
      },
      OBS: {
        title: "OBS",
        bucketName: "Bucket Name",
        storageType: "Storage Type",
        bucketStorage: "Bucket Storage",
        objectCount: "Object Count",
        createTime: "Create Time"
      }
    },
    // 资源配置管理通用项
    common:{
      update:'Update',
      multiLineExport:'Multi Line Export',
      filterByAccountName:'Account Name',
      filterByLoadName:'Load Balancing Name',
      filterByResourceName: 'Resource Name',
      QuerybyInstanceID:'InstanceID',
      QuerybyInstanceName:'Instance Name',
      QuerybyPublicIP:'PublicIP',
      PleaseSelectCompany:'Company',
      SearchbyEngine:'Engine',
      QuerybyInstanceType:'Instance Type',
      FilterbyOperatingStatus:'Operating Status',
      QuerybyBucketName:'Bucket Name',
      QuerybyClusterName:'Cluster Name',
      PleaseSelectAccount:'Account',
      PleaseSelectRegion:'Region',
      PleaseEnterAccountID:'Account ID',
      PleaseChoosePaymentMethod:'Payment Method',
      PleaseSelectStatus:'Status',
      PleaseSelectExpirationTime:'Expiration Time',
      PleaseEnterEngine:'Engine',
      PleaseSelectEngine:'Engine',
      PleaseSelectProductType:'Product Type',
      QuerybySubnetID:'Subnet ID',
      QuerybySecurityGroupID:'Security GroupID',
      PleaseSelectResourceType:'Resource Type',
      PleaseSelectEventType:'Event Type',
      PleaseSelectTimeRange:'Time Range',
      DomainName:'Domain Name',
      QuerybyStorageAccountName:'Storage Account Name',
      QuerybyResourceGroup:'Resource Group',
      PleaseSelectTagValue:'Tag Value'
    }
  },
  ApprovalTask: {
    //审批任务
    title: "Approval Task",
    approvalFlowName: "Approval Flow Name",
    submitter: "Submitter",
    category: "Category",
    status: "Status",
    launchTime: "Launch Time",
    processing: 'Processing',
    passed: 'Passed',
    rejected: 'Rejected',
    expired: 'Expired',
    selectByCompany: 'Company',
    selectByType: 'Type',
    selectAll: 'All',
    processInformation: 'Process Information',
    approvalStatus: 'Approval Status',
    startTime: 'Start Time',
    endTime: 'End Time',
    view: 'View',
    dealwith: 'Deal With',
    reservedInstancePurchase: 'Reserved Instance Purchase',
    associatedCaseID: 'Associated CaseID',
    contentOfTheParentNode: 'Content Of The Parent Node',
    matchType: 'Match Type',
    purchaseList: 'Purchase List',
    reservedInstancePurchaseList: 'Reserved Instance Purchase List',
    tip: 'Your current custom purchase of RIs is less than the expiration RI purchase quantity suggested by the system. After you save and approve the custom purchase, the system will automatically exclude the unpurchased part of the batch of RIs before the actual purchase Give an alert unless the number of RIs you need to purchase changes before the actual purchase. If the number of RIs you need to purchase changes before the actual purchase, the system will automatically generate a new approval task and delete the currently approved tasks.',
    rawData: 'Raw Data',
    standardizedQuantity: 'Standardized Quantity',
    accountName: 'Account Name',
    accountId: 'AccountId',
    region: 'Region',
    instanceCount: 'Instance Count',
    normalizationFactor: 'Normalization Factor',
    actualPurchasedQuantity: 'ActualPurchased Quantity',
    instanceType: 'Instance Type',
    price: 'Price',
    productDescription: 'Product Description',
    instanceTenancy: 'Instance Tenancy',
    offeringType: 'Offering Type',
    offeringClass: 'Offering Class',
    endDate: 'EndDate',
    duration: 'Duration'
  },
  AlertConfigManagement: {
    //报警配置管理
    CostomizedAlarm: {
      //自定义报警配置
      isAccountGroup: "Is Account Group",
      AccountGroupName: "Account Group Name",
      status: "Status",

    }
  },
  BSH: {
    resourceGroup: "Resource Group",
    resourceGroupName: "Resource Group Name",
    account: "Account",
    region: "Region",
    tagKey: "Tag Key",
    tagValue: "Tag Value",
    searchTagKey: "Tag Key",
    searchTagValue: "Tag Value",
    searchResourceGroupName: "Resource Group Name",
    add: "Add",
    basicInfo: "Basic Info",
    companyName: "Company Name",
    resourceAllocation: "Resource Allocation",
    uniqueIdentifierOfResource: "Unique Identifier Of Resource",
    searchUniqueIdentifierOfResource: "Please Select Unique Identifier Of Resource",
    alarmConfiguration: "Alarm Configuration",
    pleaseSelectNotificationObject: "Please Select Notification Object",
    pleaseSelectAlarmType: "Please Select Alarm Type",
    pleaseSelectAlarmDelay: "Please Select Alarm Delay",
    monitoringState: "Monitoring State",
    monitorIndexName: "Monitor Index Name"
  },
  MCM: {
    //MaintenanceConfigManagement
    //资源配置管理
    dutyManagement: {
      //值班管理
      title: "Operation Duty",
      editDuty: "Edit Duty",
      name: "Name",
      pleaseSelectName: "Name",
      dutyType: "Duty Type",
      pleaseSelectDutyType: "Duty Type",
      dutyTime: "Duty Time",
      pleaseSelectDutyTime: "Duty Time",
      comment: "Comment",
      operation: "Operation",
      addDuty: "Add Duty",
      priority: "Priority",
      pleaseSelectPriority: "Priority",
      dayShift: "Day Shift",
      nightShift: "Night Shift"

    },
    extraContributionManagement: {
      //额外贡献管理
      title: "Overtime",
      editExtraContribution: "Edit Extra Contribution",
      name: "Name",
      attachment: "Attachment",
      attachmentList: "Attachment List",
      PleaseSelectName: "Please select name",
      extraContributionTime: "Overtime Contribution Time",
      additionalContributionStatistics: "Additional Contribution Statistics",
      pleaseEnterExtraContributionTime: "Please enter additional time to contribute",
      extraContributionDate: "Overtime Contribution Date",
      pleaseSelectExtraContributionDate: "Please select additional year of contribution",
      description: "Description",
      pleaseEnterDescription: "Please Enter Description",
      EnterMaximumOfCharacters: "Enter a maximum of 10,000 characters",
      operation: "Operation",
      addExtraContribution: "Add Overtime Contribution",
      addExtraContributionAttachment: "Add Overtime Contribution Attachment",
      filename: "File Name",
      fileType: "File Type",
      saveAddress: "Save Address",
      PleaseSelectTheFileToUpload: "Please select the file to upload"

    },
    automaticalMaintenanceReport: {
      //自动化运维报告
      title: "Operation Report",
      companyName: "Company Name",
      pleaseSelectCompany: "Company",
      account: "Account",
      pleaseSelectAccount: "Account",
      filterByAccount: "Account",
      month: "Month",
      pleaseSelectMonth: "Month",
      region: "Region",
      pleaseSelectRegion: "Region",
      config: "Config",
      operation: "Operation",
      add: "Add",
      edit: "Edit",
      preview: "Preview",
      reportConfig: "Report Config"

    }

  },
  approvalFlowConfigManagement: {
    //审批流配置管理
    Node: {
      //节点
      title: "Node",
      addNode: "Add Node",
      nodeName: "Node Name",
      nodeCompany: "Node Company",
      user: "User",
      role: "Role",
      operation: "Operation",
      confirmAddNode: "Confirm",
      type: "Type",
      nodeType: 'Code Type',
      companyName: 'Company Name',
      queryByNodeName: 'Node Name',
      nodeNameNotEmpty: 'node name not empty',
      nodeNameValidateMsg: 'The node name is 4-20 characters',
      pleaseSelectNodeType: 'Please select node type',
      pleaseSelectUser: 'Please select user',
      pleaseSelectRole: 'Please select role',
      pleaseSelectCompany: 'Please select company',
      editNode: 'edit node',
      nodeContent : 'node content'
    },
    approvalFlow: {
      //审批流
      title: "Approval Flow",
      addApprovalFlow: "Add Approval Flow",
      approvalFlowName: "Approval Flow Name",
      approvalFlowCompany: "Approval Flow Company",
      pleaseSelectCompany: "Company",
      companyName: "Company Name",
      type: "Type",
      status: "Status",
      operation: "Operation",
      delete: "Delete",
      editButton: 'edit',
      queryByFlowName: 'Name',
      editApprovalFlow: 'edit approval flow',
      flowNameNotEmpty: 'Flow name not empty',
      flowNameValidateMsg: 'Approval flow name is 4-20 characters',
      pleaseSelectType: 'Please select type',
      connectionSucceeded: 'connection succeeded',
      nodeNotConnectingItself: 'Node does not support connecting itself',
      relationAlreadyExist: 'The relationship already exists and cannot be created repeatedly',
      nodeNotSupportLookBack: 'Does not support loopback between two nodes'
    }
  },
  LabelConfig: {
    LabelSynchronization: {
      title: "Label Synchronization",
      company: "Company",
      account: "Account",
      resourceType: "Resource Type",
      attachment: "Attachment",
      Keys: "Keys",
      attention: "Attention: Original tags will be overwritten according to the tags in the file !",
      updateTag: "Update Tags",
      synchronizingTag: "Synchronizing Tags"
    }
  },
  smartMonitor: {
    //智能监控
    dashboard: {
      //仪表盘
      title: "Dashboard",
      applicationHealthStatus: "Application Health Status",
      instanceResourceName: "Resourve Name (Instance)",
      databaseResourceName: "Resource Name (Database)",
      resourceList: "Resource List",
      accountID: "Account ID",
      accountName: "Account Name",
      instanceName: "Instance Name",
      instanceID: "Instance ID",
      weight: "Weight",
      rating: "Rating",
      operation: "Operation",
      database: "Database",
      databaseName: "Database Name",
      databaseID: "Database ID",
      resourceIndexConfig: "Resource Index Config",
      resourceType: "Resource Type",
      resourceName: "Resource Name",
      resourceID: "Resource ID",
      index: "Index",
      fittingDegreeEstimation: "Fitting Estimation",
      MonitorIndexAlert: "Monitor Index",
      currentFittingDegree: "Current Fitting Degree",
      currentIndexRating: "Current Index Rating",
      caseID: "Case ID",
      detail: "Detail",
      smartMonitorTitle: "Smart Database Monitor"
      // CPUUtilization:"CPU Utilization",
      // CPUUtilizationPrediction:"CPU Utilization Prediction",
      // cache:"Cache (MB)",
      // cacheUtilization:"Cache Utilization",
      // cacheUtilizationPrediction:"Cache Utilization Prediction",
      // readIOPStitle:"Read IOPS(count/s)",
      // readIOPS:"Read IOPS",
      // readIOPSPrediciton:"Read IOPS Prediction",
      // readIOPStitle:"Write IOPS(count/s)",
      // readIOPS:"Write IOPS",
      // readIOPSPrediciton:"Write IOPS Prediction",

    },
    applicationSystem: {
      //应用系统
      title: "Application System",
      addApplication: "Add Application",
      name: "Name",
      config: "Config",
      operation: "Operation",
      applicationConfig: "Application Config",
      addInstance: "Add Instance",
      addDatabase: "Add Database",
      instanceName: "Name",
      account: "Account",
      instanceID: "Instance ID",
      region: "Region",
      privateIP: "Private IP",
      status: "Status"
    },
    applicationSystemAlert: {
      //应用系统告警
      title: "Application System Alert",
      applicationName: "Application Name",
      resourceType: "Resource Type",
      resourceName: "Resource Name",
      resourceID: "Resource ID",
      caseID: " Case ID",
      Index: "Index",
      launchTime: "Launch Time",
      setIgnorance: "Ignorance",
      operation: "Operation",
      detail: "Detail",
      CPUUtilization: "CPU Utilization",
      CPUUtilizationPrediction: "CPU Utilization Prediction",
      cache: "Cache",
      cacheUtilization: "Cache Utilization",
      cacheUtilizationPrediction: "Cache Utilization Prediction",
      networkInput: "Network Input(Byte)",
      networkInputPrediction: "Network Input Prediction",
      networkOutput: "Network Output(Byte)",
      networkOutputPrediction: "Network Output Prediction",
      index: "Index",
      indexRating: "Index Rating",
      indexFittingDegree: "Index Fitting Degree",
      predictionValue: "Prediction Value",
      currentValue: "Current Value",
      monitorTitle: "Smart Monitor Instance"
    }
  },
tag:{
    tag: 'Tag',
    labelProcessing:'Label Processing (Under Construction)',
    setUpTagMapping: "Set up tag mapping",
    searchTagMapping: "Search Tag Mapping",
    search: "Search",
    standardTag: 'Standard tag',
    resourceTag: 'Resource tag',
    tagMapping: 'Tag mapping',
    pleaseInputTag: 'Please input tag',
    addTag: 'Add Tag',
    tagName: 'Tag name',
    thisTag: 'this Tag',
    thisMappingTag: 'this Mapping tag',
    editTag: 'Edit tag',
    pleaseSelectAwsResourceType: 'Please select AWS resource type',
    resourceId: 'Resource ID',
    resourceName: 'Resource name',
    pleaseSelectStandardTag: 'Please select standard tag',
    mappingTag: 'Mapping tag',
    addMappingTag: 'Add mapping tag',
    update:'Update'
},
resourceLifecycle:{
  purchaseAllUpfrontOneYearPrice: "Purchase Reserved Instance Price (One Year|All Upfront)",
  purchaseNoUpfrontOneYearPrice: "Purchase Reserved Instance Price (No Upfront)",
  //Common
  queryByPurpose: "Purpose",
  queryByResourceName:"Resource Name",
  filterByResourceType:"Resource Type",
  attachment:"Attachment",
  clickOrDragFileHere:"Click Or Drag File Here",
  submit:"Submit",
  process:"Approval Flow",
  virtualMachine:"Virtual Machine",
  virtualNetwork:"Virtual Network",
  objectStorage:"Object Storage",
  database:"Database",
  elasticIP:"Elastic IP",
  azureMySQLServer:"Azure MySQL server",
  azureMariaDBServer:"Azure MariaDB server",
  azureRedisServer:"Azure Redis server",
  select:"Select",
  view:"View",
  fileName:"File Name",
  fileType:"File Type",
  change:"Change",
  renew:"Renew",
  recycle:"Recycle",
  use:"Use",
  platform:"Platform",
  cloudPlatform:"Cloud Platform",
  region:"Region",
  resourceName:"Resource Name",
  resourceType:"Resource Type",
  resourceState:"Resource State",
  resourceConfig:"Resource Config",
  environment:"Environment",
  term:"Term (month)",
  startDate:"Start Date",
  endDate:"End Date",
  estimatedCost:"Estimated Cost (yuan)",
  download:"Download",
  basicInformation:"Basic Information",
  accountId:"Account Id",
  resourceGroup:"Resource Group",
  pleaseEnter:"Please Enter",
  pleaseSelect:"Please Select",
  periodOfUse:"Period Of Use",
  months:"Months",
  clickordragfilestouploadhere:"Click or drag files to upload here",
  remark:"Remark",
  application:"Application",
  produce:"Produce",
  development:"Development",
  name:"Name",
  databaseName:"Database Name",
  databaseEngine:"Database Engine",
  databaseVersion:"Database Version",
  databaseEngineVersion:"Database Engine Version",
  databaseInstanceType:"Database Instance Type",


    //资源服务目录
    resourceServiceDirectory: "Resource Service Directory",
    addResource: "Add resource",

  //资源申请
  pleasechoosecloudplatform:"Please Choose Cloud Platform",
  pleaseselectanaccount:"Please Select An Account",
  pleaseselectaregion:"Region",
  useCannotbeempty:"Use Cannot Be Empty",
  theexpirationdatecannotbeempty:"The Expiration Date Cannot Be Empty",
  pleaseselectresourcetype:"Please Select Resource Type",
  pleaseselectresourcegroup:"Please Select Resource Group",
  pleaseselectresourceenvironment:"Please Select Resource Environment",
  pleaseselectresourceprocess:"Please Select Resource Process",
  pleaseenterabackup:"Backup",
  successfulApplication:"Successful Application",
  resourceApplication:"Resource Application",
  namecannotbeempty:"Name Cannot Be Empty",
  basicinformationElasticIP:"Basic Information (Elastic IP)",
  multiAZDeployment:"Multi AZ Deployment",
  allocatedStorageSpace:"Allocated Storage Space",
  storageType:"Storage Type",
  presetIOPS:"Preset IOPS",
  masterUsername:"Master User Name",
  masterPassword:"Master Password",
  databaseParameterGroup:"Database Parameter Group",
  optionGroup:"Option Group",
  iamDatabaseAuthentication:"IAM Database Authentication",
  publicAvailability:"Public Availability",
  availabilityZone: "Availability Zone",
  subnetGroup:"Subnet Group",
  vpcSecurityGroup:"VPC Security Group",
  existingSecurityGroup:"Existing Security Group",
  selectAll:"All",
  copyTagsToSnapshot:"Copy Tags To Snapshot",
  enableDeleteProtection:"Enable Delete Protection",
  universalSSD:"Universal (SSD)",
  presetIOPSSSD:"Preset IOPS (SSD)",
  createcopiesindifferentregions:"Create Copies In Different Regions",
  no:"No",
  yes:"Yes",
  enableIAMdatabaseauthentication:"Enable IAM Database Authentication",
  disable:"Disable",
  createanewVPCsecuritygroup:"Create A New VPC Security Group",
  selectanexistingVPCsecuritygroup:"Select An Existing VPC Security Group",
  databasenamecannotbeempty:"The Database Name Cannot Be Empty",
  pleaseselectadatabaseengine:"Database Engine",
  pleaseselectthedatabaseengineversion:"Please Select The Database Engine Version",
  pleaseselectthedatabaseversion:"Please Select The Database Version",
  pleaseselectthedatabaseinstancetype:"Please Select The Database Instance Type",
  basicinformationhosteddatabase:"Basic Information (hosted database)",
  pleaseselectmultizonedeployment:"Please Select Multi-zone Deployment",
  pleaseselectstoragetype:"Please Select Storage Type",
  pleaseentertheallocatedstoragespace:"Please Enter The Allocated Storage Space",
  pleaseenterthepresetIOPS:"Please Enter The Preset IOPS",
  themainusernamecannotbeempty:"The Main User Name Cannot Be Empty",
  masterpasswordcannotbeempty:"Master Password Cannot Be Empty",
  pleaseentertheport:"Please Enter The Port",
  filterbycloudplatform:"Platform",
  account:"Account:",
  area:"Area:",
  uses:"Use",
  periodofuse:"Period Of Use:",
  flow:"Approval Flow:",
  resourceConfiguration:"Resource Configuration",
  dBInstanceClass:"DB Instance Class:",
  allottedstorage:"Allotted Storage:",
  ports:"Ports:",
  databaseParameterGroups:"Database Parameter Groups:",
  optionGroups:"Option Groups:",
  iAMDatabaseAuthentication:"IAM Database Authentication:",
  vPCSecurityGroup:"VPC Security Group:",
  existingSecurityGroups:"Existing Security Groups:",
  copylabelforsnapshot:"Copy Label For Snapshot:",
  enabledeleteprotection:"Enable Delete Protection:",
  exhibits:"Exhibits",
  remarkation:"Remarkation:",
  estimatedcost:"Estimated Cost:",
  filenames:"Filenames",
  bucketName:"Bucket Name",
  pleaseenter:"Please Enter",
  copysettingsfromanexistingbucket:"Copy Settings From An Existing Bucket",
  basicinformationobjectstorage:"Basic Information (object storage)",
  bucketname:"Bucket Name:",
  estimatedcosts:"Estimated Costs",
  enableTerminationProtection:"Enable Termination Protection",
  numberofinstances:"Number Of Instances",
  keypair:"Key Pair",
  surveillance:"Surveillance",
  webs:"Webs",
  securityGroup:"Security Group",
  automaticdistributionofpublicIP:"Automatic Distribution Of Public IP",
  disks:"Disks",
  calculationSpecifications:"Calculation Specifications",
  cloudPlatformSpecifications:"Cloud Platform Specifications",
  operatingsystem:"Operating System",
  tags:"Tags",
  pleaseselectEnableTerminationProtection:"Please Select Enable Termination Protection",
  pleaseenterthenumberofinstances:"Please Enter The Number Of Instances",
  pleaseselectakeypair:"Key Pair",
  pleaseselectMonitoring:"Please Select Monitoring",
  pleaseselectCalculationSpecification:"Please Select Calculation Specification",
  pleaseselecttheoperatingsystem:"Please Select The Operating System",
  pleaseselectamirror:"Mirror",
  pleaseselectsubnet:"Please Select Subnet",
  pleaseselectnetwork:"Please Select Network",
  pleaseselectAutoAssignPublicIP:"Please Select Auto-Assign Public IP",
  pleaseselectasecuritygroup:"Security Group",
  selects:"Selects",
  models:"Models",
  numberofCPUcores:"Number Of CPU (cores)",
  memoryGB:"Memory (GB)",
  volumeType:"Volume Type",
  availabilityZones:"Availability Zones",
  sizeGiB:"Size (GiB)",
  whethertoencrypt:"Whether To Encrypt",
  operations:"Operations",
  basicInformationVirtualMachine:"Basic Information (Virtual Machine)",
  keyPair:"Key Pair:",
  monitoring:"Monitoring:",
  network:"Network:",
  disk:"Disk:",
  numberofCPUs:"Number Of CPUs:",
  memory:"Memory:",
  rAM:"RAM",
  vPCName:"VPC Name",
  vPCIPv4CIDRblock:"VPC IPv4 CIDR block",
  iPv6CIDRblock:"IPv6 CIDR Block",
  hardwareRental:"Hardware Rental",
  subnetNameLabel:"Subnet Name Label",
  subnetIPv4CIDRblock:"Subnet IPv4 CIDR Block",
  vPCIPV4CIDRblockcannotbeempty:"VPC IPV4 CIDR Block Cannot Be Empty",
  subnetIPv4CIDRblockcannotbeempty:"Subnet IPv4 CIDR Block Cannot Be Empty",
  pleaseselectIPv6CIDRblock:"Please Select IPv6 CIDR Block",
  pleaseselectHardwareRental:"Please Select Hardware Rental",
  subnetnametagcannotbeempty:"Subnet Name Tag Cannot Be Empty",
  pleaseselectanAvailabilityZone:"Please Select An Availability Zone",
  basicInformationVirtualNetwork:"Basic Information (Virtual Network)",
  subnetNameTag:"Subnet Name Tag:",
  assign:"Assign",
  pleaseselectSKU:"Please Select SKU",
  pleaseselectAssignment:"Please Select Assignment",
  basics:"Basics",
  standards:"Standards",
  dynamically:"Dynamically",
  statically:"Statically",
  basicInformationElasticIP:"Basic Information (Elastic IP)",
  assignment:"Assignment:",
  databaseTypes:"Database Types",
  versions:"Versions",
  serverTypes:"Server Types",
  storing:"storing",
  backuphold:"Backup Hold",
  backupredundancy:"Backup Redundancy",
  username:"User Name",
  passwords:"Password",
  dNSName:"DNS Name",
  pricingLayer:"Pricing Layer",
  whethertoenableunencryptedSSL:"Whether To Enable Unencrypted SSL",
  enabling:"Enabling",
  donotenable:"Do Not Enable",
  disabling:"Disabling",
  localredundancy:"Local Redundancy",
  districtredundancy:"District Redundancy",
  pleaseselecttheversion:"Please Select The Version",
  pleaseselecttheservertype:"Please Select The Server Type",
  pleaseselectthedatabasetype:"Please Select The Database Type",
  usernamecannotbeempty:"Username Cannot Be Empty",
  pleaseenterapassword:"Please Enter A Password",
  dNSnamecannotbeempty:"DNS Name Cannot Be Empty",
  pleaseselectPricingLevel:"Please Select Pricing Level",
  pleaseselectwhethertoenablenonsslRedisserverport:"Please Select Whether To Enable Non-ssl Redis Server Port",
  pleaseentervCore:"Please Enter vCore",
  pleaseenterstorage:"Please Enter Storage",
  pleaseenterthebackuphold:"Please Enter The Backup Hold",
  pleaseselectthestorageforautogrowth:"Please Select The Storage For Auto-growth",
  pleaseselectBackupRedundancy:"Please Select Backup Redundancy",
  basicinformationmanageddatabase:"Basic Information (managed database)",
  databaseType:"Database Type:",
  serverName:"Server Name:",
  version:"Version:",
  serverType:"Server Type:",
  storage:"Storage:",
  storageAutomatedGrowth:"Storage Automated Growth:",
  password:"Password:",
  pricingTier:"Pricing Tier:",
  whethertoenablenonencryptedSSL:"Whether To Enable Non-encrypted SSL:",
  publicaccesslevel:"Public Access Level",
  storageAccounts:"Storage Accounts",
  pleaseselectPublicAccessLevel:"Please Select Public Access Level",
  pleaseselectastorageaccount:"Storage Account",
  publicAccessLevel:"Public Access Level:",
  storageAccount:"Storage Account:",
  oSDiskType:"OS Disk Type",
  pleaseselectOSDiskType:"Please Select OS Disk Type",
  series:"Series",
  addressrangecannotbeempty:"Address Range Cannot Be Empty",
  subnetName:"Subnet Name",
  addressRange:"Address Range:",
  noIPv6CIDRblock:"No IPv6 CIDR Block",
  ipv6CIDRblockprovidedbyAmazon:"IPv6 CIDR Block Provided By Amazon",

  //资源变更
  queryResources:"Query Resources",
  querybyPurpose:"Query By Purpose",
  querybyResourceName:"Query By Resource Name",
  clickordragthefiletouploadhere:"Click Or Drag File Here",
  platforms:"Platforms",
  zones:"Zones",
  surroundings:"Surroundings",
  periodmonths:"Period (months)",
  startdate:"Start Date",
  estimatedcostyuan:"Estimated Cost (yuan)",
  resourceChange:"Resource Change",
  resourcechangeinformation:"Resource Change Information",
  subnet:"Subnet:",
  add:"Add",
  delete:"Delete",
  keyupto128characters:"Key (up to 128 characters)",
  valueupto256characters:"Value (up to 256 characters)",
  addTag:"Add Tag",
  atleastonesubdimensionisrequired:"At Least One Sub-dimension Is Required",
  base:"Base",
  generalPurpose:"General Purpose",
  memoryOptimization:"Memory Optimization",

    //资源续约
    filterbyResourceType: "Filter By Resource Type ",
    renewationPeriod: "Renewation Period",
    vMs: "VMs",
    objectstorage: "Object Storage",
    manageddatabase: "Managed Database",
    pleaseselecttheflow: "Please Select The Flow",
    resourceRenew: "Resource Renew",
    resourceRenewationInformation: "Resource Renewation Information",
    renewerPeriod: "Renewer Period:",

  //资源回收
  resourceRecycle: "Resource Recycle",
  searchResource:"Search Resource",
  resourceAllocation:"Resource Allocation",
  resourceReturnOrRecycleReason:"Resource Return Or Recycle Reason",
  blobonlyanonymousreadaccessBlob:"Blob (only anonymous read access Blob)",
  containeranonymousreadaccessblob:"Container (anonymous read access blob)",
  dedicatednoanonymousaccess:"Dedicated (no anonymous access)",
  usingCIDRnotation:"The address space of the virtual network is specified as one or more address prefixes using CIDR notation (for example, 192.168.1.0/24).",
  addresourcepricecoefficient:"Add Resource Price Coefficient",

  //资源服务运营报告
  resourceRecycleInfo:"Resource Recycle Info",
  resourcespendmonthstatistics:"Resource Spend Month Statistics",
  listofresources:"List Of Resources",
  resourcesspentthismonth:"Resources Spent This Month",
  fees:"Fees:",
  numberofresources:"Number Of Resources",
  totalresourcecost$:"Total Resource Cost ($)",
  incorporation:"Incorporation",
  coefficients:"Coefficients",
  picturing:"Description",
  lastPrice:"Last Price",
  pleaseselectacompany:"Company",
  filterbyresourcetype:"Filter By Resource Type",
  companyName:"Company Name",
  resourcepricefactorconfiguration:"Resource Price Coefficient Allocation",
  resourceServiceOperationsReport:"Operation Report",
  pleaseselectDatabaseParameterGroup:"Please Select Database Parameter Group",
  pleaseselectanoptiongroup:"Please Select An Option Group",
  pleaseselectIAMDatabaseAuthentication:"Please Select IAM Database Authentication",
  pleaseselectvpc:"Please Select Vpc",
  pleaseselectSubnetGroup:"Please Select Subnet Group",
  pleaseselectPublicAvailability:"Please Select Public Availability",
  pleaseselectVPCSecurityGroup:"Please Select VPC Security Group",
  pleaseselectanexistingsecuritygroup:"Please Select An Existing Security Group",
  bucketnamecannotbeempty:"Bucket Name Cannot Be Empty",
  pleasechoosetocopysettingsfromanexistingbucket:"Please Choose To Copy Settings From An Existing Bucket",
  pleaseenteradescription:"Please Enter A Description",
  pleaseselectthecloudplatform:"Platform",
  pleaseselecttheresourcetype:"Resource Type",
  pleaseenterthecoefficient:"Coefficient",
  //Input Validation
  inputValidation:{
    requiredProcess:"Process",
    requiredResourceReturnOrRecycleReason:"Please Fill In Resource Return Or Recycle Reason",
  },
  //UI Response
  response:{
    uploadSuccess:"Upload Success",
    uploadFail:"Upload Fail",
    deleteSuccess:"Delete Success",
    recycleSuccess:"Recycle Success",
    downloadSuccess:"Download Success",
    renewSuccess: "Renew Success",
    addSuccess: "Add Success",
    addFail: "Add Fail",
    editSuccess: "Edit Success",
    editFail: "Edit Fail",
  }
},
OriginalBillEntry:{
  BillingBucketConfiguration:'Billing Bucket Configuration',
  uploadbill:'Upload Bill',
  company:'Company',
  account:'Account',
  PaymentAccount:'Payment Account',
  select:'Select',
  config:'Config',
  accountName:'Account Name',
  accountNumberName:'Account Number Name',
  accountID:'AccountID',
  bucketName:'Bucket Name',
  SynchronizeRecords:'Synchronize Records',
  del:'Del',
  cancel:'Cancel',
  confirm:'Confirm',
  region:'Region',
  month:'Month',
  upload:'Upload',
  fileName:'File Name',
  startTime:'Start Time',
  endTime:'End Time',
  syncStatus:'Sync Status',
  syncMsg:'Sync Msg',
  syncTime:'Sync Time',
  syncType: 'Sync Type',
  syncRecord:'Sync Record',
  uploadMsg:'Single Machine Or Drag Files To Upload Here',
  uploadAttachment: "Upload Attachment：",
  pleaseEnterPayAccount: "Please Enter Pay Account"
}
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en.js